
import { Contract } from './contract-en';

export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
    'FOLLOW_UP_COMMUNICATIONS': 'Follow-Up Communications',
    'SEARCH': 'Search',
    'SELECT_LOCATION': 'Select Location',
    'SELECT_TC': 'Select TC',
    'SELECT_ROLE': 'Select Role',
    'TC': 'T C',
    'PATIENT': 'Patient',
    'PATIENT_ID': 'Patient ID',
    'PATIENT_NAME': 'Patient Name',
    'TC_NAME': 'TC Name',
    'LOCATION': 'Location',
    'LOCATION_INFORMATION': 'Location Information',
    'TRIGGER': 'Touchpoints',
    'DAYS_OVER_DUE': 'Days Overdue',
    'QUOTE_EXPIRATION': 'Quote Expiration',
    'EXPIRATION': 'Expiration',
    'CONTACT': 'Contact',
    'WELCOME_UP': 'Welcome to',
    'ACCESS_PORTAL': 'Access Portal',
    'LOGIN_TO_YOUR_ACCOUNT': 'Log into your account',
    'USERNAME': 'Username',
    'PASSWORD': 'Password',
    'LOGIN': 'Login',
    'FORGOT_PASSWORD': 'Forgot Password',
    'ORTHO_CATAPULT': 'OrthoCatapult',
    'MY_PROFILE': 'My Profile',
    'PERSONAL_DETAILS': 'Personal Details',
    'FIRST_NAME': 'First Name',
    'EMP_ID': 'EMP ID',
    'ROLE': 'Role',
    'PRIMARY_LOCATION': 'Primary Location',
    'LAST_NAME': 'Last Name',
    'EMAIL': 'Email',
    'TEXT': 'Text',
    'PHONE': 'Phone',
    'DATE_OF_JOINING': 'Date of Joining',
    'ADDITIONAL_LOCATIONS': 'Additional Locations',
    'GENDER': 'Gender',
    'DATE_OF_BIRTH': 'Date of Birth',
    'CONTACT_INFO_ADDRESS': 'Contact Info - Address',
    'PROFILE_PICTURE': 'Profile Picture',
    'UPDATE': 'Update',
    'CANCEL': 'Cancel',
    'RENEW' : 'Renew',
    'CHOOSE_NEW_PLAN': 'Choose New Plan',
    'EDUCATION_SPECIALITY': 'Education - Speciality',
    'ABOUT_ME': 'About Me',
    'BUILDING_NO': 'Building No',
    'STREET_NO': 'Street No',
    'STREET_NAME': 'Street Name',
    'STATE_PROVINCE': 'State/Province',
    'STATE_TERRITORY': 'State/Territory',
    'ONE_TIME_PAYMENT': 'One Time Additional Payment',
    'ONE_TIME_PAYMENT_CONFIRM': 'One Time Additional Payment Confirmation',
    'ENTER_AMOUNT': 'Enter Amount',
    'AGREE_VALIDATION': 'Please agree to new payment amortization',
    'REDUCES_TO': 'reduces to',
    'REMAINS': 'remains',
    'CHOOSE_PAYMENT_OPTION': 'Choose payment option',
    'PROCEED_TO_PAY': 'Proceed to Pay',
    'CANCEL_PAYMENT': 'Cancel Payment',
    'CANCEL_PAYMENT_WARNING': 'Are you sure you want to cancel the One Time Additional payment?',
    'AMOUNT_EXCEED': 'Amount should not exceed remaining balance',
    'AMOUNT_BETWEEN': 'Amount should be between',
    'INVALID_AMOUNT': 'Please enter a valid amount',
    'ENTER_VALID_NUMBER': 'Please enter a valid number',
    'MONTHS_REMAINING': 'Months Remaining',
    'MONTHLY_PAYMENT_CHOOSEN': 'Monthly Payment Choosen',
    'PAY_OFF_BALANCE': 'How would you like to pay off the balance?',
    'PAY_OFF_REMAINING_BALANCE': 'Pay Off Remaining Balance',
    'TOTAL_REMAINING': 'Total Amount Remaining',
    'ADDITIONAL_PAY_AMT': 'Additional Payment Amount',
    'ADDITIONAL_NOT_EXCEED': 'Amount should not exceed remaining balance',
    'ONE_TIME_PROCEED_QUES': 'How do you wish to proceed with the one time additional payment?',
    'REDUCE_PAYMENT': 'Reduce monthly payment amount',
    'AMOUNT_REDUCES': 'Amount reduces to',
    'AROUND': 'around',
    'TOTAL_ONE_TIME': 'Total One Time Payment',
    'REDUCE_MONTH': 'Reduce months remaining',
    'LAST_MONTH_PAY': 'with last month\'s payment',
    'ACCEPTS_NEW_AMORTIZATION': 'and accepts the new payment amortization',
    'AGREE_TO': 'I agree to the',
    'ADDITIONAL': 'Additional',
    'RECEIPT': 'Receipt',
    'RECEIPT_DOWNLOAD_SUCCESS': 'Successfully downloaded payment receipt.',
    'DOWN': 'Down',
    'PROVINCE': 'Province',
    'COUNTRY': 'Country',
    'ZIP_CODE_POSTAL_CODE': 'ZIP Code/Postal Code',
    'POST_CODE': 'Postcode',
    'ALTERNATIVE_EMAIL_OPTIONAL': 'Alternative Email (Optional)',
    'PHONE_NUMBER': 'Phone Number',
    'SETTINGS': 'Settings',
    'CHANGE_PASSWORD': 'Change Password',
    'CATEGORY_MANAGEMENT': 'Category Management',
    'SET_GOALS': 'Set Goals',
    'EDIT_GOALS': 'Update Goals',
    'PRICING': 'Pricing',
    'UNIVERSAL': 'Universal',
    'GEOGRAPHY': 'Geography',
    'PRACTICE_DEMOGRAPHICS': 'Practice Demographics',
    'PRACTICE_PROFILE': 'Practice Profile',
    'DASHBOARD_REPORTS': 'Dashboard Reports',
    'LANGUAGE': 'Language',
    'CURRENT_PASSWORD': 'Current Password',
    'NEW_PASSWORD': 'New Password',
    'CONFIRM_NEW_PASSWORD': 'Confirm New Password',
    'ENTER_CUSTOM_MESSAGE': 'Enter your custom message here',
    'THIS_CONTENT_ADD_TO_EMAIL': 'This content will be added to the email and send to the patient',
    'SEND_EMAIL': 'Send Email',
    'SEND_TEXT': 'Send Text',
    'SMS_MAX_LENGTH_ERROR': 'Maximum characters should not exceed 1600',
    'LOG_OUT': 'Log Out',
    'ARE_YOU_SURE_DELETE': 'Are you sure you want to delete?',
    'YES': 'Yes',
    'NO': 'No',
    'ADD_NEW_CATEGORY': 'Add New Category',
    'LIST_CATEGORY': 'Category List',
    'NEW_CATEGORY_NAME': 'New Category Name',
    'PARENT_CATEGORY_IF_HAVE': 'Parent Category If Have',
    'SELECT_CATEGORY': 'Select Category',
    'TREATMENT_COMPLEXITY': 'Treatment Complexity',
    'CUSTOM': 'Custom',
    'CUSTOM_TREATMENT_COMPLEXITY': 'Custom Treatment Complexity',
    'NAME_CUSTOM_TREATMENT_COMPLEXITY': 'Name Custom Treatment Complexity',
    'ENTER_NAME': 'Enter Name',
    'ADD': 'Add',
    'CLOSE': 'Close',
    'CATEGORY_ID': 'Category ID',
    'CATEGORY_NAME': 'Category Name',
    'PARENT_CATEGORY': 'Parent Category',
    'ACTION': 'Action',
    'SEND': 'Send',
    'DELETE': 'Delete',
    'OPTIONAL': 'Optional',
    'DASHBOARD': 'Dashboard',
    'GLOBAL': 'Global',
    'DATE_RANGE': 'Date Range',
    'MONTHLY': 'Monthly',
    'QUARTERLY': 'Quarterly',
    'YEARLY': 'Yearly',
    'CONSULTATIONS': 'Consultations',
    'CLOSE_RATE': 'Close Rate',
    'FULL_PAYMENT': 'Full Payment',
    'AT_HOME_STARTS': 'At-Home Starts',
    'PENDING_STARTS': 'Pending Starts',
    'TOTAL_DAYS_OVERDUE': 'Total Days Overdue',
    'SAME_DAY_START': 'Same Day Starts',
    'ACCEPTED_STARTS': 'Accepted Starts',
    'ACTION_ITEM': 'Action Item',
    'ACTION_ITEMS': 'Action Items',
    'NAME_OF_TC': 'Name of TC',
    'DAYS_OVERDUE': 'Days Overdue',
    'PATIENT_REFERRAL_LIST': 'Patient Referral List',
    'REFFERED_BY': 'Referred By',
    'BEST_CONTACT_METHOD': 'Best Contact Method',
    'OWNER': 'Owner',
    'DATE_OF_REFERRAL': 'Date of Referral',
    'PENDING_DAYS': 'Pending Days',
    'NEW_PRACTICES': 'NEW PRACTICES',
    'USERS_AROUND': 'Users around',
    'GLOBE': 'globe',
    'CASE_FEE_GENERATED': 'Case Fee Generated',
    'NEW_PRACTICE': 'New Practice',
    'CREATE_DEMO': 'Create Demo',
    'CASE_STUDY': 'Case study',
    'MANAGE': 'Manage',
    'PROMO_CODE': 'Promo Code',
    'CODE_LENGTH': 'Code Length',
    'CODE_MSG':'6-12 characters long. Must be Alphanumeric',
    'PERCENTAGE_DISCOUNT': 'Percentage Discount',
    'ACTIVE_PROMO_CODE': 'Active Promo Code',
    'TIER': 'Tier',
    'SELECT_PROMO_CODE': 'Select Promo Code',
    'VIEW': 'View',
    'REPORTS': 'Reports',
    'CONSULTATION': 'Consultation',
    'ACCEPTED_RATE': 'Accepted rate',
    'RED_DAYS': 'Overdue days',
    'OVERALL_STATISTICS': 'Overall statistics',
    'GRAPH': 'Graph',
    'COMMUNICATION': 'Communication',
    'SOME_ACTION': 'Some Action',
    'CATEGORY_BREAKDOWN': 'Category Breakdown',
    'CREATE_PATIENT_FILE': 'Create Patient File',
    'RECENT_PATIENT_FILES': 'Recent Patient Files',
    'ADD_NEW_PATIENT': 'Add New Patient',
    'CASE_TYPE_INITIAL': 'Initial',
    'CASE_TYPE_PREFERENCE': 'Preference',
    'CASE_TYPE': 'Initial Preference',
    'CREATE_CASE_STUDY': 'Create Case Study',
    'EDIT_CASE_STUDY': 'Edit Case Study',
    'SELECT_TREATMENT_GROUP': 'Select Treatment Group',
    'FIELD_REQUIRED': 'Field required',
    'CASE_STUDY_NAME': 'Case Study Name',
    'TREATMENT_DURATION': 'Treatment Duration',
    'PATIENT_AGE': 'Patient Age',
    'PHOTO_COURTESY': 'Photo Courtesy',
    'SELECT_TREATMENT_COMPLEXITY': 'Select Treatment Complexity',
    'AUXILIARIES_USED': 'Auxiliaries Used',
    'ADDITIONAL_NOTES': 'Additional Notes',
    'UPLOAD_PHOTOS': 'Upload Photos',
    'BEFORE': 'Before',
    'AFTER': 'After',
    'UPLOAD': 'Upload',
    'UPLOAD_TESTIMONIAL_VIDEO': 'Upload Testimonial Video',
    'ADD_VIDEO_LINKS': 'Add Video Link',
    'VIDEO_URL': 'Add video URL',
    'UPLOAD_EDUCATIONAL_VIDEO': 'Upload Educational Video',
    'SAVE_CASE_STUDY': 'Save Case study',
    'UPDATE_CASE_STUDY': 'Update Case Study',
    'ALLOCATE_SAMPLE_CASE_STUDIES': 'Allocate sample case studies',
    'SELECT_PRACTICE_NAME': 'Select Practice Name',
    'SHOW': 'Show',
    'ALLOCATE': 'Allocate',
    'SET_AS_TOP': 'Set as top',
    'ADD_TO_REFERRAL_ALBUM': 'Add to Referral Album',
    'REMOVE_FROM_TOP': 'Remove from Top',
    'REMOVE_FROM_REFERRAL_ALBUM': 'Remove from Referral Album',
    'VIEW_CASE_STUDY': 'View Case Study',
    'PRACTICE_STRUCTURE': 'Practice Structure',
    'PREV_YEAR_ANNUAL_START_PROVIDER': "Previous Year's Annual Starts Per Provider",
    'GEOGRAPHIC_MEDIAN_HOUSE_HOLD_INCOME': 'Geographic Median Household Income',
    'PREV_YEAR_PRACTICE_ANNUAL_START': "Previous Year's Practice Annual Starts",
    'OPTIONAL_PREV_YEAR_ALIGNER_SHARE': "Optional Previous Year's Overall Aligner Share",
    'SAVE_DEMOGRAPHICS': 'Save Demographics',
    'PRICING_SETTINGS': 'Pricing Settings',
    'MONTHS': 'Months',
    'PRICE': 'Price',
    'MINIMUM_DP': 'Minimum Down Payment',
    'MAXIMUM': 'Maximum',
    'EXTENTED_PAYMENTS': 'Extended Payments',
    'SAVE': 'Save',
    'PRACTICE_LOCATIONS': 'Practice Location(s)',
    'STREET_ADDRESS': 'Street Address',
    'STREET_ADDRESS_1': 'Street Address 1',
    'STREET_ADDRESS_2': 'Street Address 2',
    'ZIP_CODE': 'ZIP Code',
    'POSTAL_CODE': 'Postal Code',
    'CITY': 'City',
    'SAVE_LOCATIONS': 'Save Location',
    'EDIT_LOCATIONS': 'Update Location',
    'GOAL_TIME_FRAME': 'Goal Time frame',
    'CHOOSE_TC_DOCTOR': 'Choose TC/Doctor',
    'APPLY_TO_ALL': 'Apply to all',
    'GOALS': 'Goals',
    'CASE_STARTS': 'Case Starts',
    'HEIGHT': 'Height',
    'PIXEL': 'Pixel',
    'WIDTH': 'Width',
    'OR': 'or',
    'RATIO': 'ratio',
    'PRACTICE_NAME': 'Practice Name',
    'PRACTICE_LOGO': 'Practice Logo',
    'NUMBER_OF_PRACTICE_LOCATIONS': 'Number of Practice Locations:',
    'SUBSCRIPTION_PERIOD': 'Subscription Period',
    'SUBSCRIPTION_ACTIVATION': 'Subscription Activation',
    'SUBSCRIPTION_ACTIVATION_TEXT': 'Please activate your OrthoCatapult subscription plan for the practice details shown below:',
    'FROM': 'From',
    'TO': 'to',
    'SUPER_ADMIN_COO_NAME': 'Practice Admin',
    'PRACTICE_ADMIN_CONTACT_NUMBER': 'Practice Admin Contact Number',
    'NUMBER_OF_LOCATION_SUBSCRIPTION': 'Number of Locations/Subscription',
    'UPGRADE': 'Upgrade',
    'CANCEL_AUTO_RENEWAL': 'Cancel Auto-Renewal',
    'PRACTICE_ADMIN_EMAIL': 'Practice Admin Email',
    'SAVE_PROFILE': 'Save Profile',
    'PRE_POPULATED': 'PrePopulated',
    'UNIVERSAL_PRICING_SETTINGS': 'Universal Pricing Settings',
    'EXTENDED_PAYMENT_INTREST_RATES': 'Extended Payment Interest Rates',
    'PAY_IN_FULL_DISCOUNT': 'Pay in Full Discount',
    'PAY-IN-FULL_DISCOUNT': 'Pay-in-Full Discount',
    'PAY_IN_FULL_DISCOUNT_SETTINGS': 'Pay in Full Discount Settings',
    'DOWN_PAYMENT_DISCOUNT': 'Down Payment Discount',
    'LARGE_DOWN_PAYMENT_DISCOUNT_SETTINGS': 'Large Down Payment Discount Settings',
    'LARGE_DOWN_PAYMENT_DISCOUNT': 'Large Down Payment Discount',
    'ADD_DOWN_PAYMENT_DISCOUNT': 'Enable Large Down Payment Discount',
    'ENABLE_LARGE_DOWN_PAYMENT_DISCOUNT': 'Enable Large Down Payment Discount',
    'MINIMUM_PATIENT_RESPONSIBILITY': 'Minimum % of Total Patient Responsibility',
    'MINIMUM_DISCOUNTED_TREATMENT_PRICE' : 'Minimum % of Discounted Treatment Fee ',
    'ENABLE_RETAINER_SUBSCRIPTION':'Enable Retainer Subscription Program',
    'LIFETIME_RETAINER_FEE': 'Lifetime Retainers Fee',
    'SELECTED_BY_DEFAULT': 'Selected by Default',
    'FEE_AMOUNT': 'Fee Amount',
    'DISCOUNT_RATE': 'Discount Rate',
    'TREATMENT_PLAN': 'Treatment Plan',
    'SEND_PLAN': 'Send Plan',
    'RESEND_PLAN': 'Resend Plan',
    'PRESENT_PLAN': 'Present Plan',
    'TREATMENT_GROUP': 'Treatment Group',
    'TREATMENT_CATEGORY': 'Treatment Category',
    'TX_CATEGORY': 'Tx Category',
    'PROJECTED_TREATMENT_TIME': 'Projected Treatment Time',
    'RISK_RATING': 'Risk Rating',
    'MAXIMUM_EXTENDED_PAYMENT_INTREST': 'Maximum Extended Payment Interest',
    'ESTIMATED_INSURANCE_COVERAGE': 'Estimated Insurance Coverage',
    'COURTESY_DISCOUNT': 'Courtesy Discount',
    'REFERRAL_DOCTOR': 'Referral Doctor',
    'TREATMENT_COORDINATOR': 'Treatment Coordinator',
    'COORDINATOR': 'Coordinator',
    'INITIAL_TREATMENT_PREFERENCE': 'Initial Treatment Preference',
    'INITIAL_TX_PREFERENCE': 'Initial Tx Preference',
    'DOCTOR': 'Doctor',
    'PARENT_ORTHO_RELAPSE': 'Parent Ortho Relapse Candidate',
    'TREATMENT_OPTIONS': 'Treatment Options',
    'PLAN_PRICE': 'Plan Price',
    'MINIMUM_DOWN_PAYMENT': 'Minimum Down Payment',
    'MINIMUM_DOWN_FOR_DISCOUNT': 'Minimum Large Down Payment % for Discounts',
    'LARGE_DOWN_PAYMENT_DICOUNT_RATE': 'Large Down Pay Discount Rate',
    'MAXIMUM_EXTENDED_MONTHLY_PAYMENT': 'Maximum Extended Monthly Payments(EMP)',
    'ADDITIONAL_APPLIANCE_FEE': 'Additional Appliance Fee',
    'CASE_STUDIES': 'Case Studies',
    'IMAGES': 'images',
    'VIDEO': 'video',
    'CREATED_ON': 'Created On',
    'VIEW_ALL': 'View All',
    'VIEW_LESS': 'View Less',
    'PAYMENT_PLAN_OVERVIEW': 'payment plan overview',
    'TOTAL_TREATMENT_COST': 'Total Treatment Cost',
    'TOTAL_TREATMENT_FEE':'Total Treatment Fee',
    'COURTESY': 'Courtesy',
    'PATIENT_RESPONSIBILITY': 'Patient Responsibility',
    'PAYMENT_PLAN': 'Payment Plan',
    'DOWN_PAYMENT': 'Down Payment',
    'MONTHLY_PAYMENT': 'Monthly Payment',
    'NUMBER_MONTHLY_PAYMENT': 'Number of Monthly Payments',
    'QUOTE_EXPIRATION_DATE': 'Quote Expiration Date',
    'DOWN_PAYMENT_RECIEVED': 'Down Payment Received',
    'DOWN_PAYMENT_DATE': 'Down Payment Date',
    'PAYMENT_SCHEDULE': 'Payment Schedule',
    'PRINCIPLE': 'Principle',
    'PAYMENT': 'Payment',
    'RATE': 'Rate',
    'REVIVE': 'Revive',
    'TRANSFER': 'Transfer',
    'INTEREST': 'Interest',
    'Max_EMP_INTEREST': 'Max EMP Interest',
    'PRACTICE_LOCATION': 'Practice Location',
    'MAX_EXTENDED_PAYMENTS': 'Max Extended Payments (+)',
    'CASE_STUDY_GALLLERY': 'Case Study Gallery',
    'PHOTOS': 'Photos',
    'PHOTOS_COURTESY_OF': 'Photos Courtesy of',
    'TESTIMONIAL_VIDEO': 'Testimonial Video',
    'EDUCATIONAL_VIDEO': 'Educational Video',
    'REFER_PATIENT': 'Refer Patient',
    'PATIENT_LAST_NAME': 'Patient Last Name',
    'PATIENT_FIRST_NAME': 'Patient First Name',
    'PATIENT_CONTACT_NUMBER': 'Patient Contact Number',
    'PATIENT_EMAIL_ID': 'Patient Email ID',
    'CASE_CATEGORY_OBSERVED': 'Case Category Observed',
    'NOTES': 'Notes',
    'SUBMIT': 'Submit',
    'REMAINING': 'Remaining',
    'UNTIL': 'Until',
    'EXPIRES': 'Expires',
    'DAYS': 'Days',
    'WEEKS': 'Weeks',
    'LEFT_TO': 'Left to',
    'EXPIRE': 'expire',
    'CASE': 'case',
    'QUOTE': 'quote',
    'ESTIMATED_TREATMENT_LENGTH': 'Estimated Treatment Length',
    'OTHER_DISCOUNTS': 'Other Discounts',
    'TOTAL_PATIENT_RESPONSIBILITY': 'Total Patient Responsibility',
    'CHOOSE_A': 'Choose a',
    'TO_REDUCE_YOUR_MONTHLY_PAYMENTS': 'to reduce your monthly payments',
    'THAT_BEST_FITS_YOUR_BUDGET_BY_CHANGING': 'that best fits your budget by changing',
    'THE_TOTAL_NUMBER_OF_MONTHS': 'the total number of months',
    'DISCOUNTS': 'Discounts',
    'OF_MONTHS': 'Of Months',
    'ACCEPT': 'accept',
    'DECLINE': 'Decline',
    'SORRY': 'Sorry!',
    'INVALID_URL': 'Invalid URL',
    'ORTHO_CALCULATOR': 'Calculator',
    'HEALTH_ID': 'Health ID',
    'DETAILS': 'Details',
    'REFERRAL_SOURCE': 'Referral Sources',
    'RISK_CATEGORY': 'Risk Category',
    'SELECT_CASE': 'Select Case',
    'CONTACT_INFO': 'Contact Info',
    'ENTER_NAME_OF_THE_CONTACT': 'Enter Name of the Contact',
    'RELATIONSHIP': 'Relationship',
    'RELATION': 'Relation',
    'CREATE_TREATMENT_PALN': 'Create Treatment Plan',
    'PATIENT_FILES': 'Patient Files',
    'SEARCH_PATIENT': 'Search',
    'LAST_INITIAL': 'Last Initial',
    'CONTACT_NUMBER': 'Contact Number',
    'TWILIO_NUMBER': 'Twilio Number',
    'NAME_OF_CONTACT': 'Name of Contact',
    'ENTRIES': 'entries',
    'SHOWING': 'Showing',
    'OF': 'of',
    'VIEW_PATIENT_FILE': ' View Patient File',
    'ID': 'ID',
    'DOB': 'DOB',
    'EDIT_PATIENT': 'Edit Patient',
    'CREATE_NEW_TREATMENT_PLAN': 'Create New Treatment Plan',
    'PREVIOUS_TREATMENT_PLAN': 'Previous Treatment Plan',
    'NOT_RECEIVED': 'Not Received',
    'TREATMENT_HISTORY': 'Treatment History',
    'TREATMENT': 'Treatment',
    'START_DATE': 'Start Date',
    'END_DATE': 'End Date', 
    'COST': 'Cost',
    'PLAN_ID': 'Plan ID',
    'ESTIMATED': 'Estimated',
    'FINISH_DATE': 'Finish Date',
    'ACTUAL': 'Actual',
    'NUMBER': 'Number',
    'NAME_OF': 'Name of',
    'NO_OF_LOCATIONS': 'Number of Locations',
    'DEFAULT_LANGUAGE': 'Default Language',
    'PRACTICE_EMAIL_OR_USERNAME': 'Practice Email ID/User Name',
    'TEMPORARY_PASSWORD': 'Temporary Password',
    'SEND_ACCESS_DETAILS_TO': 'Send Access Details to',
    'TRYING_TO_REMOVE_PRACTICE': 'You are trying to permanently delete a practice',
    'TO_REMOVE': 'To delete',
    'PLEASE_ENTER': 'please enter',
    'AND_PRESS_CONFIRM': 'and press confirm button',
    'ENTER_THE_TEXT_HERE': 'Enter the text here',
    'CONFIRM': 'Confirm',
    'PRACTICE_CONTACT_NAME': 'Practice Contact Details',
    'SEARCH_PRACTICE': 'Search Practice',
    'ADD_PRACTICE': 'Add Practice',
    'PRACTICE_ID': 'Practice ID',
    'CONTACT_PERSON': 'Contact Person',
    'SUBSCRIPTION_STARTED_ON': 'Subscription started on',
    'SUBSCRIPTION_ENDS_BY': 'Subscription ends by',
    'VIEW_PRACTICE': 'View Practice',
    'EDIT': 'Edit',
    'CREATE_NEW_REFERRING_DOCTOR': 'Create New Referring Doctor',
    'GP_DENTIST_DETAILS': 'Referring Doctor Details',
    'CLINIC_HOSPITAL_NAME': 'Clinic/Hospital Name',
    'REFERRAL_TYPE': 'Referral Type',
    'EMAIL_ID': 'Email',
    'SEARCH_REFERRING_DOCTOR': 'Search',
    'ADD_NEW_REFERRING_DOCTOR': 'Add New Referring Doctor',
    'REFERRAL_ID': 'Referral ID',
    'DOCTOR_FIRST_NAME': 'First Name',
    'DOCTOR_LAST_INITIAL': 'Last Initial',
    'DOCTOR_LAST_NAME': 'Last Name',
    'REF_TYPE': 'Ref. Type',
    'REFERRAL_ADDED_BY': 'Referral Owner',
    'EDIT_REFERRING_DOCTOR': 'Edit Referring Doctor',
    'DELETE_REFERRING_DOCTOR': 'Delete Referring Doctor',
    'FROM_APPLIANCE_LIST': 'from your Additional Appliance list?',
    'RECORD_DELETE_CONFIRMATION': 'This record will be deleted from the list. Are you sure?',
    'RECORD_DELETE_CONFIRMATION_ON_SET': 'These records will be deleted from the list. Are you sure?',
    'PATIENT_LAST_INITIAL': 'Patient Last Initial',
    'DATE_REFERRED': 'Date Referred',
    'DAYS_PENDING': 'Days Pending',
    'DATE_CONTACTED': 'Date Contacted',
    'ASSIGN_TC': 'Assign TC',
    'ASSIGN': 'Assign',
    'TREATMENT_COORDINATOR_NAME': 'Treatment Coordinator Name',
    'SELECT_TREATMENT_CATEGORY': 'Select Treatment Category',
    'TREATMENT_CATEGORY_CREATED': 'Treatment Category added successfully',
    'SELECT_LANGUAGE': 'Select Language',
    'CONSULTATION_FOLLOW_UP_COMMUNICATIONS': 'Consultation Follow-Up Communications',
    'PAY_IN_FULL': 'pay-in-full',
    'SAME_DAY_STARTS': 'same day starts',
    'START_NOW': 'Start Now !',
    'START': 'Start',
    'OK': 'Okay',
    'CROP_LOGO': 'Crop Your Logo',
    'MALE': 'Male',
    'FEMALE': 'Female',
    'NON_BINARY': 'Non-Binary',
    'ADD_USER': 'Add User',
    'EMPL_ID': 'Emp ID',
    'DATE_JOIN': 'Date of Join',
    'USER_MANAGEMENT': 'User Management',
    'LOCATION_ID': 'Location ID',
    'NAME': 'Name',
    'STREET': 'Street',
    'DELETE_LOCATION': 'Delete Location',
    'I_APPROVE_THE': 'I approve the',
    'TERMS_OF_SERVICE': 'terms of service',
    'PAY_WITH': 'Pay with',
    'STRIPE': 'stripe',
    'SIMPLE_PRICING': 'Simple Pricing. No Surprises.',
    'UPGRADE_OR_DOWNGRADE': 'Upgrade or downgrade anytime',
    'GET_DISCOUNT': 'Multi-Year Plans = Huge Savings',
    'SELECT': 'Select',
    'ALL': 'All',
    'SUBSCRIPTION_FOR': 'Subscription for ',
    'OFF': 'off',
    'ANNUAL_SAVING': 'Annual Savings',
    'YEAR': 'Year',
    'ALL_REGIONS': 'All Regions',
    'ALL_LOCATIONS': 'All Locations',
    'ALL_DEMOGRPAHICS': 'Demographics',
    'CREATE_SAMPLE_CASE_STUDY': 'Create Sample Case Study',
    'RE_ASSIGN_TC': 'Re-Assign TC',
    'POSITIVE_VALUE': 'Enter valid data',
    'ENGLISH': 'English',
    'SPANISH': 'Spanish',
    'FRENCH': 'French',
    'ADD_MESSAGE': 'Add Message',
    'USER_ROLE': 'User Role',
    'EMP_EMAIL_ID': "Emp. Email ID",
    'DATE_OF_JOIN': 'Date of Join',
    'INCOMPLETE_DETAILS': 'Incomplete Details',
    'TREATMENT_COMPLEXITY_NOT_SELECTED': 'Treatment Complexity not Selected',
    'CUSTOM_TREATMENT_CATEGORY_NOT_ENTERED': 'Custom Treatment Category not entered',
    'CATEGORY_NOT_CREATED': 'Failed to create Category',
    'CATEGORY_EDIT_SUCCESS': 'Category edited successfully',
    'CATEGORY_EDIT_FAIL': 'Failed to edit Category',
    'CATEGORY_DELETE_SUCCESS': 'Category deleted successfully',
    'CATEGORY_DELETE_FAIL': 'Failed to delete Category',
    'TC_UPDATE_SUCCESS': 'TC updated successfully',
    'TC_ASSIGN_SUCCESS': 'Assigned TC successfully',
    'TC_UPDATE_FAIL': 'Failed to update TC',
    'UPDATE_CONTACT_DETAIL_SUCCESS': 'Contacted date updated successfully',
    'UPDATE_CONTACT_DETAIL_FAIL': 'Failed to update details',
    'EMAIL_SEND_SUCCESS': 'Email sent Successfully',
    'EMAIL_SEND_FAIL': 'Failed to send email',
    'DOCUSIGN_LINK_SUCCESS': 'DocuSign linked successfully',
    'DOCUSIGN_LINK_ERROR': 'DocuSign link error',
    'NO_IMAGE_UPLOADED': 'No images uploaded',
    'IMAGES_UPLOADED': 'Images uploaded',
    'FILL_REQUIRED_DETAILS': 'Fill required details',
    'CASE_STUDY_CREATED': 'Case study created',
    'SOMETHING_WENT_WRONG': 'Something went wrong',
    'DUPLICATE_CARD_ERROR': 'The card already exists',
    'CASE_STUDY_EDIT_SUCCESS': 'Case Study edited successfully',
    'CASE_STUDY_ALLOCATED': 'Case Study allocated',
    'CASE_STUDY_ALLOCATION_FAIL': 'Case study allocation failed',
    'DEMOGRAPHIC_SAVE_SUCCESS': 'Practice demographic saved successfully',
    'DEMOGRAPHIC_SAVE_FAIL': 'Failed to save practice demographic details',
    'PRICING_LIST_UPDATE_SUCCESS': 'Pricing list updated successfully',
    'PRICING_LIST_UPDATE_FAIL': 'Pricing list update failed',
    'ALL_FIELDS_REQUIRED': 'All fields are required',
    'LOCATION_UPDATE_SUCCESS': 'Location Updated Successfully',
    'LOCATION_ADD_SUCCESS': 'Location Added Successfully',
    'GOAL_SAVE_FAIL': 'Failed to save goal',
    'LANGUAGE_UPDATED': 'Language Updated',
    'LANGUAGE_UPDATE_FAIL': 'Failed to update language',
    'PRACTICE_CREATE_SUCCESS': 'Practice created successfully',
    'PRACTICE_CREATE_FAIL': 'Failed to create practice',
    'PRACTICE_UPDATE_SUCCESS': 'Practice updated successfully',
    'PRACTICE_UPDATE_FAIL': 'Failed to update practice',
    'PRACTICE_DELETED': 'Practice deleted',
    'PRACTICE_DELETE_FAILED': 'Failed to delete the practice',
    'UNIVERSAL_PRICE_UPDATE_SUCCESS': 'Universal pricing list updated successfully',
    'PROVIDE_VALID_EMAIL': 'Please provide a valid email',
    'INCOMPLETE_REFERRAL_DETAILS': 'Incomplete Referral Details',
    'PATIENT_REFERRAL_CREATED': 'Patient referral created successfully',
    'PLAN_SEND_SUCCESS': 'Plan sent successfully',
    'FILL_REQUIRED_FIELD': 'Fill in required fields',
    'PATIENT_FILE_CREATE_SUCCESS': 'Patient file created successfully',
    'PATIENT_FILE_CREATE_FAIL': 'Failed to create patient file',
    'PATIENT_FILE_UPDATE_SUCCESS': 'Patient file updated successfully',
    'PATIENT_FILE_UPDATE_FAIL': 'Failed to update patient file',
    'EMAIL_NOT_VALID': 'Email ID not valid',
    'USERNAME_ALREADY_EXIST': 'Username already exists',
    'PROFILE_NOT_UPDATED': 'Profile details not updated',
    'PROFILE_UPDATED': 'Profile updated successfully',
    'REF_DOCTOR_CREATE_SUCCESS': 'Referral doctor created successfully',
    'REF_DOCTOR_DELETE_SUCCESS': 'Doctor details deleted successfully',
    'REF_DOCTOR_DELETE_NOT_POSSIBLE': 'Delete not allowed since referral exists',
    'REF_DOCTOR_UPDATE_SUCCESS': 'Doctor details updated successfully',
    'DELETED': 'Deleted Successfully',
    'NOT_DELETED': 'Not deleted',
    'PASSWORD_UPDATE_SUCCESS': 'Password updated successfully',
    'PASSWORD_UPDATE_FAIL': 'Failed to update password',
    'PASSWORD_NOT_MATCH': 'Password does not match',
    'SELECT_TREATMENT_OPTION': 'Please select a treatment option',
    'TREATMENT_PLAN_SAVE_SUCCESS': 'Treatment plan saved successfully',
    'PLEASE_SELECT_CASE_STUDY': 'Please select a case study',
    'TREATMENT_PLAN_ALREADY_STARTED': 'Treatment plan already started',
    'TREATMENT_PLAN_SENT_SUCCESS': 'Successfully sent treatment plan',
    'TREATMENT_PLAN_SENT_ERROR': 'Some error occurred while sending plan',
    'INVALID_PARENT_CATEGORY': 'Invalid parent category',
    'CATEGORY_IS_IN_USE': 'Category is currently in use',
    'CURRENT_PLAN_DETAILS': 'CURRENT PLAN DETAILS',
    'SUBSCRIPTION_REQUIRED_COO': 'Please select your OrthoCatapult subscription plan options below:',
    'SUBSCRIPTION_REQUIRED_COO_EXPIRED_1': 'Your OrthoCatapult subscription plan has been expired, please select your new subscription plan options below to proceed:',
    'SUBSCRIPTION_REQUIRED_COO_EXPIRED_2': 'Oops! it seems your existing plan has expired',
    'SUBSCRIPTION_REQUIRED_COO_INITIAL': 'To complete your account activation, please enter your payment information below:',
    'SUBSCRIPTION_REQUIRED_COO_IN_GRACE': 'Please update your payment information below:',
    'SUBSCRIPTION_REQUIRED_ADDITIONAL_LOCATION': "You have an Additional Location Payment pending. Please update your payment information below:",
    'SUBSCRIPTION_REQUIRED_OUT_GRACE': 'Please update your payment information below to pay your overdue balance and reactivate your account:',
    'ACCOUNT_DEACTIVATED': 'Your account is now overdue and has been temporarily deactivated.',

    'OOPS': 'Oops',
    'ACCOUNT_PAST_DUE': 'Your scheduled OrthoCatapult subscription payment has failed and your account is now past due.',
    'UPDATE_PAYMENT_INFO_BELOW': 'Please update your payment information below:',
    'IF_PAYMENT_NOT_RECEIVED_BY': 'If your overdue payment(s) is not received by',
    'ACCOUNT_FUNCTIONALITIES_RESTRICTED_UNTIL_PAYMENTS_RECEIVED': "access to your OrthoCatapult account will be restricted until all past due payments are received.",
    'IMMEDIATELY_UPDATE_PAYMENT_INFO': 'Please update your payment information below to prevent account restrictions.',
    'PAYMENT_FAILED_BEYOND_GRACE_PERIOD': "Your practice's OrthoCatapult® subscription payment is more than 14 days past due; access to OrthoCatapult is now restricted until the overdue balance is received.",
    'ACCOUNT_RESTRICTED_UNTIL_PAYMENTS_RECEIVED': "Your account has now been restricted untill all past due payments are received.",
    'UPDATE_PAYMENT_INFO_RESTORE_ACCESS': "Please update the practice's credit card payment details below to immediately restore access.",
    'ACCOUNT_RESTRICTIONS_IMMINENT': 'Account Restrictions Imminent',
    'ACCOUNT_RESTRICTED': 'Account Restricted',
    'ACCOUNT_ACCESS_RESTRICTED': 'Account Access Restricted',
    'ACCOUNT_PAST_DUE_TITLE': 'Account Past Due',
    'FAILED_PAST_DUE': 'Your credit card payment has failed, and your account is now past due.',
    'UPDATE_PAYMENT_IMMEDIATELY': "Please update your practice's payment details below to pay your overdue balance immediately.",

    'SUBSCRIPTION_REQUIRED': 'Please contact your Admin!',
    'SUBSCRIPTION_REQUIRED_ENTERPRISE': 'Please contact us at support@practicecatapult.com to request additional practice locations.',
    'ACTIVATE_NOW': 'Activate Now',
    'UPDATE_PAY_NOW': 'Update & Pay Now',
    'LOGOUT': 'Logout',
    'USER_CREATE_SUCCESS': 'User created successfully',
    'USER_NOT_CREATED': 'User not Created',
    'USER_UPDATE_SUCCESS': 'User updated successfully',
    'USER_NOT_UPDATED': 'User not updated',
    'VIEW_USER': 'View User',
    'NO_DATA_FOUND': 'No Data Found',
    'INCORRECT_PASSWORD': 'Incorrect Current Password',
    'CONGRATULATIONS': 'Congratulations!',
    'NO_DATA_AVAILABLE': 'No Data Available',
    'NO_TEAM': 'No team member meet this criteria.',
    'NO_LOCATION': 'No location meet this criteria.',
    'NO_PRACTICE': 'No practice meet this criteria.',
    'OTHER_LOCATION': 'Other Location',
    'INVALID_INPUT': 'Invalid Input',
    'UN_AUTHORIZED': 'You are not authorized, Please login',
    'SENT_EMAIL_TO_PATIENT': 'Email has been sent to the patient',
    'VERIFICATION_EMAIL': 'Verification Email send',
    'CASE_STUDY_UPDATED': 'Case study updated successfully',
    'CASE_STUDY_DELETED': 'Case study deleted',
    'CASE_STUDY_ASSIGNED': 'Case study assigned successfully',
    'CASE_STUDY_TOP_THREE_LIMIT': 'Top 3 case studies already set',
    'CASE_STUDY_THREE_REFERRAL_LIMIT': '3 case studies already added to referral album',
    'CASE_STUDY_PHOTOS_CREATED': 'Created case study photos',
    'CASE_STUDY_PHOTOS_DELETED': 'Case study photos deleted',
    'CASE_STUDY_PHOTO_UPDATED': 'Updated case study photo',
    'CASE_STUDY_PHOTO_DELETED': 'Deleted case study photo',
    'GOAL_CREATED': 'Goal saved successfully',
    'GOAL_UPDATED': 'Goal updated successfully',
    'GOAL_DELETED': 'Goal deleted successfully',
    'INVALID_EMPLOYEE_ID': 'Employee Id Invalid',
    'PATIENT_FILE_CREATED': 'Patient file created successfully',
    'PATIENT_FILE_UPDATED': 'Patient file updated successfully',
    'PATIENT_FILE_DELETED': 'Patient file deleted',
    'PATIENT_REFERRAL_UPDATED': 'Patient referral updated successfully',
    'PATIENT_REFERRAL_DELETED': 'Patient referral deleted',
    'PATIENT_REFERRAL_CONTACT_UPDATED': 'Patient referral contact updated successfully',
    'PATIENT_REFERRAL_NOT_FOUND': 'Patient referral not found',
    'INVALID_OWNER': 'Owner Invalid',
    'INVALID_PATIENT_FILE': 'Patient file invalid',
    'PRACTICE_CREATED': 'Practice created successfully',
    'PRACTICE_UPDATED': 'Practice updated successfully',
    'PRACTICE_LOCATION_CREATED': 'Created practice location',
    'PRACTICE_LOCATION_UPDATED': 'Updated practice location',
    'PRACTICE_LOCATION_DELETED': 'Deleted practice location',
    'PRACTICE_LOCATION_DEMOGRAPHIC_UPDATED': 'Practice demographic location updated',
    'DOCUSIGN_LINKED': 'DocuSign linked',
    'PRICING_UPDATED': 'Pricing updated successfully',
    'PROMO_CODE_CREATED': 'Promo code created successfully',
    'PROMO_CODE_APPLIED': 'Promo code applied successfully',
    'UNIVERSAL_PRICING_UPDATED': 'Universal pricing updated successfully',
    'FOLLOW_UP_NOT_FOUND': 'Follow up not found',
    'FOLLOW_UP_CONTACT_UPDATED': 'Follow up contact updated successfully',
    'TREATMENT_PLAN_DELETED': 'Treatment plan deleted',
    'TREATMENT_PLAN_UPDATED': 'Treatment plan updated successfully',
    'TREATMENT_CATEGORY_UPDATED': 'Treatment category updated successfully',
    'TREATMENT_CATEGORY_DELETED': 'Treatment category deleted',
    'TREATMENT_GROUP_NOT_PROVIDED': 'Treatment group not provided',
    'TREATMENT_STARTED': 'Treatment started',
    'TREATMENT_DECLINED': 'Treatment declined',
    'USER_CREATED': 'User created successfully',
    'USER_UPDATED': 'User updated successfully',
    'USER_DELETED': 'User deleted',
    'USER_NOT_LOGGED_IN': 'User not logged in',
    'PASSWORD_CHANGED': 'Password changed',
    'GP_CREATED': 'GP created',
    'GP_DELETED': 'GP deleted',
    'GP_UPDATED': 'GP updated',
    'USERNAME_EXISTS': 'Username already exists',
    'USER_NOT_FOUND': 'User not found',
    'PASSWORD_RECOVERY_TOKEN_SENT': 'Password recovery token sent',
    'CARD_CREATED': 'Card created',
    'CARD_DELETED': 'Card deleted',
    'CARD_MARKED_AS_PRIMARY': 'Cared marked as primary',
    'CARD_NOT_ATTACHED': 'Card not attached',
    'SUBSCRIPTION_CREATED': 'Subscription created',
    'TREATMENT_CATEGORY_CURRENTLY_IN_USE': 'Treatment category is currently in use',
    'INVALID_PROMO_CODE': 'Invalid promo code',
    'NO_PROMO_CODE': 'No promo code',
    'DECLINE_PLAN': 'Plan Declined',
    'PATIENT_MAIL_ID': 'Patient Mail ID',
    'PATIENT_PHONE_NUMBER': 'Patient Phone Number',
    'EDIT_PATIENT_FILE': 'Edit Patient File',
    'NEW_PATIENT_FILE': 'New Patient File',
    'EDIT_PRACTICE': 'Edit Practice',
    'ADD_AND_SET_GOALS': 'Add & Set Goals',
    'EDIT_USER': 'Edit User',
    'AUTO_RENEWAL': 'Auto-Renewal',
    'PRACTICE_NOT_SELECTED': 'Practice not selected',
    'CASE_STUDY_NOT_SELECTED': 'Case study not selected',
    'TREATMENT_LENGTH': 'Treatment Length',
    'RISK': 'Risk',
    'PATIENT_NOT_REFERRED': 'Patient not Referred',
    'PATIENT_REFERRED': 'Patient Referred',
    'USERS_IN': 'Users in',
    'EMAIL_PLAN': 'Email Plan',
    'CASE_GALLERY': 'Case Gallery',
    'VIEW_CASE_GALLERY': 'View Case Gallery',
    'ONLINE': 'Online',
    'MARKETING': 'Marketing',
    'PATIENT_REFERRAL': 'Patient Referral',
    'REFERRING_DOCTORS': 'Referring Doctors',
    'PROFESSIONAL_REFERRALS': 'Professional Referrals',
    'MOTHER': 'Mother',
    'FATHER': 'Father',
    'BOTH': 'Both',
    'SELECT_PARENT_ORTHO_RELAPSE_CANDIDATE': 'Select parent ortho relapse candidate',
    'CONTACT_FIRST_NAME': 'Contact First Name',
    'CONTACT_LAST_NAME': 'Contact Last Name',
    'CONTACT_NAME': 'Contact Name',
    'GUARDIAN': 'Guardian',
    'REFERRAL_PATIENT': 'Referral Patient',
    'REFERRAL_FORM_LINK': 'Referral Form Link',
    'SLIDER_VIEW': 'Slider View',
    'NORMAL_VIEW': 'Normal View',
    'UPGRADE_SUBSCRIPTION': 'Upgrade Subscription to add more locations',
    'GO_TOSUBSCRIPTION': 'Go to Subscription',
    'CONTACT_METHOD': 'Contact Method',
    'NOT_VALID_URL': 'Provide a valid URL',
    'NOT_VALID_YOUTUBE_VIMEO_URL': 'Provide a valid URL (Youtube or Vimeo)',
    'YEAR_OF_BIRTH': 'Year of Birth',
    'SELECT_SUBSCRIPTION_PERIOD': 'Select Subscription Period',
    'SUBSCRIBE': 'Subscribe',
    'CLONE': 'Clone',
    'SELECT_CANDIDATE': 'Select Candidate',
    'ADD_TO_DEFAULT': 'Add to default',
    'REMOVE_FROM_DEFAULT': 'Remove from default',
    'CHANGE_REFERRER': 'Change Referrer',
    'REFERRER': 'Referrer',
    'REFERRER_CHANGE_SUCCESS': 'Referrer changed successfully',
    'CHANGE_TC': 'Change TC',
    'SELECT_TREATMENT_SUB_CATEGORY': 'Select Treatment Subcategory',
    'TREATMENT_SUB_CATEGORY': 'Treatment Subcategory',
    'TX_SUB_CATEGORY': 'Tx Subcategory',
    'RENAME_OPTION_D': 'Rename Option PRACTICE_LOD',
    'NEW_NAME': 'New Name',
    'GET_QUOTE': 'Get Quote',
    'BUY_NOW': 'Buy Now',
    'SEND_MAIL': 'Send Mail',
    'PASSWORD_RESET_LINK': 'Password Reset link sent successfully',
    'INVALID_USERNAME': 'Invalid Username',
    'RESET_PASSWORD': 'Reset Password',
    'EDIT_CATEGORY': 'Edit Category',
    'TREATMENT_PLAN_UPDATE_SUCCESS': 'Treatment plan updated successfully',
    'PAY_NOW': 'Pay Now',
    'CARD_ADDED_SUCCESSFULLY': 'Card added successfully',
    'APPLY_TAX': 'Apply Tax',
    'NET_PRICE': 'Net Price',
    'VAT_IF_APPLICABLE': 'VAT (if applicable)',
    'FOR_ONE_YEAR': 'for one year',
    'ASSIGN_COLOR': 'Assign color',
    'REASSIGN_COLOR': 'Reassign color',
    'DATA_TO': 'Data to ',
    'SELECT_GROUPS': 'Select Groups',
    'SUBSCRIPTION': 'Subscription',
    'SUBSCRIPTION_EXPIRED': 'Subscription Expired',
    'ACTIVATION_PAYMENT_DUE': 'Activation Payment Due',
    'STARTED_ON': 'Started on',
    'ENDS_ON': 'Ends on',
    'PAGE_NOT_FOUND': 'Page Not Found',
    'LOOKS_LIKE_GOT_LOST': 'Looks like you’ve got lost.',
    'PAGE_NOT_EXIST': 'The page you’re looking for doesn’t exist or has been moved.',
    'GO_HOME': 'Back to Home',
    'PRICE_GREATER_THAN_ZERO': 'Plan price should be greater than zero',
    'INSURANCE_COVERAGE_GREATER_THAN_PRICE': 'Estimated insurance coverage should be less than plan price',
    'COURTESY_DISCOUNT_GREATER_THAN_PRICE': 'Courtesy discount should be less than plan price',
    'PATIENT_RESPONSIBILITY_GREATER_THAN_ZERO': 'Patient Responsibility should be greater than zero',
    'TOTAL_TREATMENT_FEE_GREATER_THAN_ZERO': 'Total Treatment Fee should be greater than zero',
    'DISCOUNTED_TREATMENT_NOT_NEGATIVE': 'Discounted Treatment Fee should not be negative',
    'TREATMENT_OPTION_NAME_SETTINGS': 'Treatment Option Name Settings',
    'OPTION': 'Option',
    'RESTORE_DEFAULT': 'Restore Default',
    'PROMOCODE_MANAGEMENT': 'Promo Code Management',
    'CREATE_PROMOCODE': 'Create Promo Code',
    'ENTER_PROMOCODE': 'Enter Promo Code',
    'ALPHANUMERIC': 'Alphanumeric',
    'NUMERIC': 'Numeric',
    'CODE': 'Code',
    'VALID_FROM': 'Valid From',
    'VALID_TO': 'Valid To',
    'VALID_FOR': 'Valid for',
    'PATTEREN_ERROR': 'Require at least one letter & one number',
    'LENGTH_ERROR': 'Minimum 6 characters required',
    'ALPHANUMERIC_ERROR': 'Only letters and numbers are allowed',
    'ALL_PACKAGES': 'All Packages',
    'ONE_YEAR': 'One Year',
    'THREE_YEAR': 'Three Year',
    'FIVE_YEAR': 'Five Year',
    'DISCOUNT': 'Discount',
    'PROMOTIONAL_DISCOUNT': 'Promotional Discount',
    'CREATE': 'Create',
    'PROMO_CODE_ALREADY_EXISTS': 'Promo code already exists',
    'PROMO_CODE_ADDED': 'Promo code added',
    'PROMOCODES': 'PROMO CODES',
    'PROMOCODE': 'Promo Code',
    'CODE_ID': 'Code Id',
    'APPLICABLE': 'Applicable',
    'GOAL_ID': 'Goal ID',
    'ROLE_TYPE': 'Role',
    'LOCATIONS': 'Locations',
    'PRACTICES': 'Practices',
    'TIME_FRAME': 'Time Frame',
    'CONSULTAIONS': 'Consultations',
    'GOAL_DELETE_ERROR': 'Failed to delete goal',
    'DELETE_GOAL': 'Delete Goal',
    'GOAL_UPDATE_FAIL': 'Failed To Update Goal',
    'APPLY': 'Apply',
    'VALUE_RANGE': 'Value should be in range',
    'SELECT_ATLEAST_ONE_TREATMENT_OPTION': 'Select at least one treatment option',
    'NO_TREATMENT_OPTION_SELECTED': 'Treatment option is not selected',
    'SELECT_TREATMENT_GROUP_FOR_PRICE': 'Select the treatment group to view the pricing section',
    'NO_TREATMENT_GROUP_FOR_PRICE': 'The treatment group is not selected to view the pricing section',
    'SELECT_TC_ERROR': 'Please select at least one TC/Doctor',
    'DECLINE_PAYMENT_PLAN_CONFIRMATION1': `This treatment plan will be DECLINED and the Responsible Party will immediately receive the
        Declined Treatment email automatically.`,
    'DECLINE_PAYMENT_PLAN_CONFIRMATION2': `If you want to edit this plan instead, please click Cancel and then the Edit button under
        the Treatment Plan to modify this treatment plan.`,
    'DECLINE_PAYMENT_PLAN_CONFIRMATION3': `Are you sure you want to DECLINE the treatment plan?`,
    'UPDATE_CONTACTED_DATE_CONFIRMATION': 'Last contacted date will be updated. Are you sure?',
    'ADD_NEW_SUBCATEGORY': 'Add New Subcategory',
    'NEW_SUBCATEGORY_NAME': 'New Subcategory Name',
    'SUFFIX_PREFIX_LENGTH_GREATER': 'Suffix-Prefix length should be less than code length ',
    'HISTORIC_DATA': 'Historical Data',
    'WRONG_CAPTCHA': 'Wrong Captcha',
    'PAYMENT_SUCCESS': 'Payment Success!',
    'PAYMENT_FAILED': 'Payment Failed',
    'REACTIVATION_FAILED': 'Reactivation Failed',
    'REACTIVATION_SUCCESS': 'Successfully reactivated your subscription',
    'ADD_HISTORICAL_DATA': 'Add Historical Data',
    'EDIT_HISTORICAL_DATA': 'Edit Historical Data',
    'NUMBER_OF_CONSULTATIONS': '# of Consultations',
    'NUMBER_OF_SIGNED_CONTRACT': '# of Signed Contracts',
    'CLEAR': 'Clear',
    'SAVE_AND_ADD_ANOTHER': 'Save & add another',
    'MONTH': 'Month',
    'SELECT_MONTH': 'Select Month',
    'SELECT_YEAR': 'Select Year',
    'ADD_ACCOUNT': 'Add Account',
    'ENTERPRISE_ACCOUNTS': 'Enterprise Accounts',
    'CONTRACT_PERIOD': 'Contract Period',
    'SUBSCRIPTION_TERM': 'Subscription Term',
    'CURRENT_SUBSCRIPTION_TERM': 'Current Subscription Term',
    'SUBSCRIPTION_START_DATE': 'Subscription Start Date',
    'INVAILD_SUBSCRIPTION_START_DATE': 'Invalid subscription start date',
    'ANNUAL_PAYMENT_DATE': 'Annual Payment Date',
    'GRACE_PERIOD': 'Grace Period',
    'ENTERPRISE_ACCOUNT': 'Enterprise Account',
    'NEXT_ANNUAL_PAYMENT_DATE': 'Next Annual Payment Date',
    'SUBSCRIPTION_RENEWAL_DATE': 'Subscription Renewal Date',
    'CONTACT_EMAIL_ID': 'Contact Email ID',
    'INVOICE_MAIL_ID': 'Invoice Mail ID',
    'BILLING_ADDRESS': 'Billing Address',
    'PRIMARY_BILLING_ADDRESS': 'Primary / Billing Address',
    'PRACTICE_ADMIN_DETAILS': 'Practice Admin Details',
    'UNIT_APARTMENT_NUMBER': 'Unit/Apartment Number',
    'STATE': 'State',
    'SAME_AS_CONTACT_MAIL': 'Same as contact mail',
    'ENTERPRISE_CREATE_SUCCESS': 'Enterprise created successfully',
    'ENTERPRISE_UPDATE_SUCCESS': 'Enterprise updated successfully',
    'ENTERPRISE_DELETED': 'Enterprise deleted',
    'LENGTH_EXCEEDED': 'Length limit exceeded',
    'ENTERPRISE_USERS': 'Enterprise users',
    'MAILING_ADRESS': 'Mailing Address',
    'UNIT_NO': 'Unit No',
    'PARENT_GUARDIAN': 'Parent/Guardian',
    'PARENT': 'Parent',
    'ORDER': 'Order',
    'EXISTING': 'Existing',
    'EXISTING_PATIENT_OR_FAMILY': 'Existing Patient/Family?',
    'FAMILY': 'Family',
    'EMAIL_TEMPLATE': 'Email Templates',
    'CREATE_EMAIL': 'Create Email',
    'NEW_MESSAGE': 'New Message',
    'SUBJECT': 'Subject',
    'DATE': 'Date',
    'TIME': 'Time',
    'AGE': 'Age',
    'EXISTING_FAMILY_OR_PATIENT': 'Existing Family/Patient?',
    'CLEAR_FILTERS': 'Clear',
    'HISTORY_ADD_SUCCESS': 'Historical data added successfully',
    'HISTORY_UPDATE_SUCCESS': 'Historical data updated successfully',
    'HISTORY_DELETE_SUCCESS': 'Historical data deleted successfully',
    'TREATMENT_CATEGORY_NAME_ALREADY_EXISTS': 'Treatment category name already exists',
    'CATEGORY_ORDER': 'Category Order',
    'SUBCATEGORY_ORDER': 'Subcategory Order',
    'PREVIOUS_MAIL': 'Previous Mail',
    'PREVIEW': 'Preview',
    'ENTER_SUBJECT': 'Enter a subject',
    'MAIL_SENT': 'Mail sent',
    'CC': 'Cc',
    'BCC': 'Bcc',
    'BACK': 'Back',
    'MAKE_PAYMENT': 'Make Payment',
    'SELECT_OR_CREATE_CARD': 'Select or create card',
    'ADD_CARD': 'Add New Card',
    'ADD_PAYMENT_SOURCE': 'Add Payment Source',
    'INVALID_DATE': 'Invalid Date',
    'DASHBOARD_DISPLAY_REPORT': 'Dashboard Display Reports',
    'SELECT_THREE_REPORTS': 'Select the reports to be displayed in the dashboard',
    'REPORT': 'Report',
    'FIRST': 'First',
    'SECOND': 'Second',
    'THIRD': 'Third',
    'ALL_PATIENTS': 'All Patients',
    'ENTER_TO_ADDRESS': 'Enter to address',
    'PLAN_CREATED': 'Plan Created',
    'PLAN_ACCEPTED': 'Plan Accepted',
    'STRIPE_LINK_SUCCESS': 'Stripe link success',
    'STRIPE_LINK_ERROR': 'Stripe link failure',
    'SETUP_DOCUSIGN': 'Setup DocuSign',
    'CONNECT_WITH_STRIPE': 'Connect with Stripe',
    'DOCUSIGN_ID': 'DocuSign ID',
    'STRIPE_ID': 'Stripe ID',
    'MINIMUM_DOWN_FOR_DISCOUNT_%': 'Minimum Large %',
    'NO_PREFERENCE': 'No Preference',
    'FEE': 'Fee',
    'TREATMENT_MODALITY': 'Treatment Modality',
    'CURRENCY': 'Currency',
    'SUITE_NO': 'Suite No',
    'MINIMUM_DOWN': 'Min Down',
    '%_PATIENT_RESPONSIBILITY': '% of Patient Responsibility',
    '%_DISC_TX_FEE': '% Disc Tx Fee',
    'DISCOUNTED_TREATMENT_FEE': 'Discounted Treatment Fee',
    'SELECT_TREATMEN_MODALITY': 'Select Treatment Modality',
    'SELECT_TREATMENT_OPTION_NAME': 'Select Treatment Option Name',
    'INITIAL_PAYMENT': 'Initial Payment',
    'MONTHLY_PAYMENT_DEDUCTED_AUTOMATICALLY': 'Monthly Payments Will Be Debited Automatically',
    'PASSWORD_LENGTH_ERROR': 'Password length should be at least six characters',
    'INVALID_NUMBER': 'Invalid phone number',
    'ADD_CONTRACT': 'Add Contract',
    'CLEAR_ALL':'Clear All',
    'NEW_PDF':'New PDF',
    'CLEAR_DOCISIGN_DATA': 'Clear All Contract Data',
    'CLEAR_DOCISIGN_DATA_DESCRIPTION':'All data, including data tags and the PDF file, will be cleared.',
    'ENTER_PASSWORD': 'Enter your password',
    'INVALID_PASSWORD': 'Password incorrect',
    'LAST_ACCESSED': 'Last accessed',
    'LAST_MAIL_SENT': 'Last mail sent',
    'PAYMENT_DECLINED': 'Payment Declined',
    'DOWN_PAYMENT_GREATER_THAN_ZERO': 'Minimum down payment should be greater than zero',
    'QUOTE_TRIGGER_UPDATED': 'Quote and touchpoints updated',
    'TRIGGER_GREATER_THAN_ZERO': 'Touchpoints should be greater than zero',
    'TRIGGER_LESS_THAN_QUOTE_VALIDITY': 'Touchpoints should be less than quote validity',
    'PAYMENT_METHOD': 'Payment Method',
    'MARK_AS_READ': 'Mark as read',
    'NO_NOTIFICATIONS': 'No notifications',
    'PAY_IN_FULL_DISCOUNT_RATE': 'Pay in Full Discount Rate',
    'IMMEDIATE_PAY': 'Immediate Pay',
    'DISCOUNT_CALCULATION': 'Down Payment Discount Calculation',
    'APPLY_TO_DISC_TX_FEE': 'Apply to Entire Discounted Treatment Fee',
    'APPLY_TO_PATIENT_RESP_ONLY': 'Apply to Estimated Patient Responsibility Only',
    'UPDATE_DISCOUNT_CALCULATION': 'Update Discount Calculation',
    'UPDATE_DISCOUNT_CALCULATION_CONFIRMATION': 'Do you want to update the discount calculation option?',
    'DISCOUNT_CALCULATION_UPDATED': 'Discount Calculation updated',
    'PAY-IN-FULL_DISCOUNT_RATE': 'Pay-in-Full Discount Rate',
    'CUSTOM_CONTRACTS': 'Custom Contracts',
    'DOCISIGN_NOT_UPDATED': 'DocuSign not updated',
    'UPLOAD_A_PDF_FILE': 'Upload a pdf file',
    'ADD_TAGS': 'Add Tags inside pdf',
    'LOCATION_IN_USE': 'Cannot delete. Location in use',
    'LOCATION_DELETED': 'Location deleted successfully',
    'PRACTICE_ACTIVE': 'Cannot delete. Practice is active',
    'ENTERPRISE_ACTIVE': 'Cannot delete. Enterprise is active',
    'ADD_REFERRAL_DOCTOR': 'Add New Referring Doctor',
    'LARGE_DOWN_PAY_DISCOUNT': 'Large Down Pay Discount',
    'BASED_PATIENT_REPONSIBILITY': 'Based on Patient Responsibility',
    'PRICING_UPDATE_WARNING':'Pricing Update Warning',
    'PRICING_UPDATE_WARNING_CONTENT':'There is a change in pricing so the values will be updated',
    'BASED_DISCOUNTED_TX_FEE': 'Based on Discounted Treatment Fee',
    'ALL_TRIGGER_FIELDS_REQUIRED': 'Enter all touchpoints days',
    'ENTER_QUOTE_VALIDITY': 'Enter quote validity',
    'COLOR_NOT_SELECTED': 'Please select color',
    'INVALID_BIRTH_YEAR': 'Please enter a valid year of birth',
    'GOALS_AND_ACHIEVEMENTS': 'Goals & Achievements',
    'HELLO': 'Hello',
    'YOU_HAVE_ACHIEVED': 'You have achieved',
    'YOUR': 'Your',
    'DASHBOARD_REPORTS_CHANGED': 'Dashboard Reports Changed',
    'OKAY': 'Okay',
    'DOWN_PAYMENT_LESS_THAN_PRICE': 'Down Payment should not exceed plan price',
    'DOWN_PAYMENT_LESS_THAN_PATIENT_RESPONSIBILITY': 'Down Payment should not exceed patient responsibility',
    'SELECT_CARD': 'Select Card',
    'ALL_GROUPS': 'All Groups',
    'GOAL': 'Goal',
    'COMMUNICATION_HISTORY': 'Communication History',
    'CONTACTED_METHOD': 'Contacted Method',
    'SL_NO': 'Serial No',
    'TIME_CONTACTED': 'Time Contacted',
    'SHOW_REFERRAL_GALLERY_LINK': 'Show referral gallery link',
    'CHOOSE_FILE': 'Choose File',
    'UPLOAD_COMPOSITE_PHOTOS': 'Upload Composite Photos',
    'COMPOSITE_PHOTOS': 'Composite Photos',
    'CLICK_TO_VIEW': 'Click to view',
    'CROP_IMAGE': 'Crop Image',
    'MAX_TREATMENT_OPTIONS_ALLOWED': 'Maximum 3 treatment options allowed',
    'PAYMENT_OPTIONS': 'Payment Options',
    'PDF_PASSWORD': 'PDF Password',
    'PDF_DESC_1': 'This password protects PDF files created in OrthoCatapult® containing sensitive patient & financial details.',
    'PDF_DESC_2': 'Password must have 8+ characters and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.',
    'CHOOSE_TREATMENT_OPTION': 'Choose Treatment Option',
    'ESTIMATED_TREATMENT_DURATION': 'Estimated Treatment Duration',
    'TRADEMARK_AND_OWNERSHIP': 'All trademarks, trade names, product names and logos appearing on the site are the property of their respective',
    'OWNERS': 'owners.',
    'IS_A_REGISTERED_TRADEMARK_OF': 'is a registered trademark of',
    'IS_A_TRADEMARK_OF': 'is a trademark of',
    'AT_OFFICE': 'At Office',
    'AT_HOME': 'At-Home',
    'STRIPE_PROFILE': 'Stripe Profile',
    'DOCUSIGN_PROFILE': 'DocuSign Profile',
    'PAYMENT_OPTIONS_UPDATED': 'Payment options updated',
    'IN_OFFICE': 'In-Office',
    'SCHEDULE_CONSULTATION': 'Schedule Consultation',
    'MESSAGE_SEND_SUCCESS': 'Message sent successfully',
    'MESSAGE_SEND_FAIL': 'Failed to send Message',
    'PROCEED_TO_DOCUSIGN': 'Proceed to DocuSign',
    'BILLING_ADDRESS_UPDATED': 'Billing address updated',
    'YEARS': 'Years',
    'AUTO_RENEW_SUBSCRIPTION': 'Auto Renew Subscription',
    'MONTHLY_AUTO_RENEWAL': 'Monthly Auto-Renewal',
    'RENEWAL_DATE': 'Renewal Date',
    'LOCATION_USED': 'Location Used',
    'LOCATIONS_USED': 'Locations Used',
    'NUMBER_OF_LOCATIONS': 'Number of Locations',
    'LOCATION_AVAILABLE': 'Location Available',
    'LOCATION_ADDED': 'Location added',
    'LOCATION_NOT_ADDED': 'Location not added',
    'CART_OVERVIEW': 'Cart Overview',
    'ACCOUNT': 'Account',
    'LEGAL': 'Legal',
    'PRACTICE': 'Practice',
    'ADDRESS': 'Address',
    'CONFIRM_PASSWORD': 'Confirm Password',
    'STEPS': 'Steps',
    'COMPLETE': 'Complete',
    'MAKE': 'Make',
    'VERIFY': 'Verify',
    'INVALID_CONTACT_NO': 'Invalid contact number',
    'CONGRATS': 'Congrats',
    'SENT_VERIFICATION_MAIL_TO': 'We have sent a verification link to the mail',
    'VERIFY_ACCOUNT': 'We just need to verify your account before you can go to next step',
    'RESEND': 'Resend',
    'VERIFIED': 'Verified',
    'ACCOUNT_NOT_VERIFIED': 'Account not verified',
    'LOCATION_LIMIT_EXCEEDED': 'Location limit exceeded for selected practice structure',
    'DELETE_PROTECTED': 'Failed to delete patient file. Associated treatment plans exists',
    'DELETE_PROTECTED_TX': 'Payment received. Unable to Delete.',
    'LOCATIONS_AVAILABLE': 'Location Available',
    'VERIFICATION_ERROR': 'Email verification failed',
    'VERIFICATION_SUCCESS': 'Email verified successfully',
    'AUTO_RENEWAL_UPDATED': 'Auto renewal updated',
    'TOTAL_INTEREST': 'Total Interest',
    'PAYMENT_SUMMARY': 'Payment Summary',
    'APPROVE': 'Approve',
    'PLEASE_LOGIN_TO_ACCESS': 'Please login to access treatment plan and OrthoGallery',
    'PAY_IN_FULL_DISCOUNT_RATE_LESS_ERROR': "Pay in full discount rate should not be less than down payment discount",
    'CLONE_CASE_STUDY': 'Clone Case Study',
    'BUY': 'Buy',
    'VIEW_COMMUNICATION_HISTORY': 'View Communication History',
    'OPEN_COMMUNICATION_HISTORY': 'Open Communication History',
    'NO_COMMUNICATION_HISTORY': 'No Communication History',
    'UPDATE_DEMOGRAPHICS': 'Update Demographics',
    'DEMOGRAPHIC_UPDATE_SUCCESS': 'Practice demographic updated successfully',
    'DEMOGRAPHIC_UPDATE_FAIL': 'Failed to update practice demographic details',
    'SHOW_HISTORY': 'Show History',
    'HIDE_HISTORY': 'Hide History',
    'REFERRING_DOCTOR_INFORMATION': 'Referring Doctor Information',
    'PRINCIPAL': 'Principal',
    'BALANCE': 'Balance',
    'BALANCE_DUE_DETAILS': 'Balance Due Details',
    'LEGAL_DISCLAIMER': 'Legal Disclaimer',
    'SUBSCRIPTION_PAYMENT_INFORMATION': 'Subscription Payment Information',
    'CARD_ON_FILE': 'Card on File',
    'EXPIRATION_DATE': 'Expiration Date',
    'UPDATE_PAYMENT_INFORMATION': 'Update Payment information',
    'CARD_INFO_NOT_AVAILABLE': 'Card Information not available.',
    'SELECT_DEFAULT_CARD': 'Select Default Card',
    'MAKE_AS_DEFAULT': 'Make as Default',
    'DEFAULT_CARD_UPDATED': 'Default card updated',
    'REFERRING_DOCTOR': 'Referring Doctor',
    'REFERRING_TYPE': 'Referring Type',
    'PACKAGE': 'Package',
    'BILL_MONTHLY': 'Bill Monthly',
    'BILL_ANUALLY': 'Bill Annually',
    'SUBSCRIPTION_UPDATED': 'Subscription updated',
    'PATIENT_PAYMENT_DETAILS': 'Patient Payment Details',
    'TREATEMENT_STARTED_ON': 'Treatment Started on',
    'FIRST_PAYMENT': 'First Payment',
    'TREATEMENT_COST': 'Treatment Cost',
    'TREATEMENT_FEE': 'Treatment Fee',
    'BALANCE_AMOUNT': 'Balance Amount',
    'PAYMENT_DETAILS': 'Payment Details',
    'DOWN_PAYMENT_RECEIVED': 'Down Payment Received',
    'TOTAL_PAYMENT': 'Total Payment',
    'STATUS': 'Status',
    'SUCCESS': 'Success',
    'FAILED': 'Failed',
    'UPCOMING': 'Upcoming',
    'RETRY': 'Retry',
    'RECEIVED_OFFLINE': 'Received Offline',
    'PAYMENT_UPDATED': 'Payment Updated Successfully',
    'FIND_YOUR_PAYMENT_DETAILS': 'Find your Payment Details',
    'AMOUNT': 'Amount',
    'PAYMENT_CARD_INFORMATION': 'Payment Card Information',
    'CARD_NUMBER': 'Card Number',
    'ADD_PAYMENT_INFORMATION': 'Add Payment information',
    'CHANGE_CARD': 'Change card',
    'PAYMENT_TYPE': 'Payment Type',
    'DATE_RECEIVED':'Date Received',
    'DEMO_SUBSCRIPTION_MESSAGE': '(Will be updated on Renewal)',
    'TREATMENT_LENGTH_GREATER_THAN_ZERO': 'Treatment length should be greater than zero',
    'TREATMENT_LIMITED_LENGTH_GREATER_THAN_ZERO': 'LIMITED treatment length should be greater than zero',
    'CLONE_CONFIRMATION': 'Are you sure you want to clone',
    'GLOBALLY': 'globally',
    'FOR': 'for',
    'DONE': 'Done',
    'TERMS_LICENSE_CONTENT_USE': 'Terms of Licensee Content Use',
    'LICENSEE_CONTENT_PERMISSIONS': 'Licensee Content & Permissions',
    'PATIENT_GUARDIAN_TALENT_RELEASES': 'Patient & Guardian Talent Releases',
    'SHARING_LICENSEE_CONTENT': 'Sharing Licensee Content',
    'LICENSEE_CONTENT_RESPONSIBILITIES': 'Licensee Content Responsibilities',
    'LICENSORS_CONTENT': 'Licensor’s Content',
    'COPYRIGHT': 'Copyright',
    'COPYRIGHT_AGENT': 'Copyright Agent',
    'PRACTICE_CATAPULT_LLC': 'Practice Catapult LLC',
    'PRACTICE_ADRRESS_1': '9790 Gratiot Rd, Suite 1',
    'PRACTICE_ADRRESS_2': 'Saginaw, Michigan 48609',
    'SUBSCRIPTION_PRICING': 'Subscription Pricing',
    'SUBSCRIPTION_PRICES_UPDATED': 'Subscription prices updated',
    'ADDITIONAL_PRICES_UPDATED': 'Additional prices updated',
    'CONTACT_ADMIN': 'Contact Admin',
    'TO_DECLINE': 'To decline',
    'RENEWAL': 'Renewal',
    'CURRENT': 'Current',
    'RESEND_PASSWORD': 'Resend Password',
    'ADD_ADDITIONAL_LOCATIONS': 'Add Additional Location',
    'SELECT_PAYMENT_SOURCE':'Select Payment Source',
    'YOU_WILL_BE_CHARGED_AN':'You will be charged an',
    'YOUR_SUBSCRIPTION': 'Your Subscription',
    'GET_STARTED': 'GET STARTED',
    'PROCEED': 'PROCEED',
    'NO_OF_LOCATIONS_GREATER_THAN_CURRENT': 'No of locations should not be less than current value',
    'NO_OF_LOCATIONS_GREATER_THAN_ZERO': 'No of locations should be greater than zero',
    'IMAGE_SIZE_GREATER_THAN_2MB': 'Image size should not be greater than 2 MB',
    'MY_CART': 'My Cart',
    'YOUR_PURCHASE': 'Your Purchase',
    'PLAN': 'Plan',
    'SEARCH_PLAN': 'Search Plan',
    'TREATMENT_APPROVAL_LIST': 'Treatment Approval List',
    'EXPIRES_AT': 'Expires At',
    'APPROVED': 'Approved',
    'WAITING': 'Waiting',
    'WAITING_FOR_APPROVAL': 'Waiting for Approval',
    'ACTIVATE': 'Activate',
    'DEACTIVATE': 'Deactivate',
    'USER_ACTIVATED': 'User Activated',
    'USER_DEACTIVATED': 'User Deactivated',
    'EMAIL_WAITING_MESSAGE': 'You will receive an email from us once your contract is approved.',
    'DEMO_CASE_STUDY': 'Demo case study',
    'FOLLOW_UP': 'Follow-up',
    'REFERRAL': 'Referral',
    'INITIAL_DOWN_PAYMENT': 'Initial Down Payment',
    'BALANCE_REMAINING': 'Balance Remaining',
    'AMOUNT_DUE': 'Amount Due',
    'ACCESS_HISTORY': 'Access History',
    'RESPONSIBLE_PARTY_CONTACT_INFO': 'Responsible Party Contact Info',
    'RESPONSIBLE_PARTY_DOB': 'Responsible Party Date of Birth',
    'QUOTE_EXPIRATION_DAYS': 'Quote Expiration Days',
    'APPLY_FILTER': 'Apply Filter',
    'CHANGE_FILTER': 'Change Filter',
    'QUOTE_EXPIRATION_DAY_LOWER_LIMIT_GREATER_THAN_UPPRER_LIMIT': 'Expiration day upper limit should be greater than lower limit',
    'FILTER_APPLIED': 'Filter applied successfully',
    'FILTER_CLEARED': 'Filter cleared successfully',
    'NO_PATIENTS_FOUND': 'No patient found',
    'UPLOAD_DOCUMENT': 'Please upload contract document to proceed further.',
    'CONTRACT_LIST': 'Contract List',
    'INITIAL_VIEW': 'Initial View',
    'SELECT_INITIAL_VIEW': 'Select Initial View',
    'CREATED_AT': 'Created at',
    'HIDE_OFFICE_PAYMENT': 'Hide office payment',
    'GALLERY_LINK': 'Gallery Link',
    'INSURANCE_PLAN_MANAGEMENT': 'Insurance Plan Management',
    'ADD_INSURANCE_PLAN': 'Add Insurance Plan',
    'INSURANCE_PLANS': 'Insurance Plans',
    'SELECTED_INSURANCE_PLANS': 'Selected Insurance Plans',
    'ADD_NEW_PLAN': 'Add New Insurance Plan',
    'EDIT_PLAN': 'Edit Insurance Plan',
    'INSURANCE_PLAN_ADDED': 'Insurance plan added successfully',
    'INSURANCE_PLAN_UPDATED': 'Insurance plans updated successfully',
    'INSURANCE_PLAN_EDITED': 'Insurance plan edited successfully',
    'INSURANCE_PLAN_DELETED': 'Insurance plan deleted successfully',
    'INSURANCE_PLAN': 'Insurance Plans',
    'SET_INSURANCE_PLAN': 'Set Insurance Plans',
    'SET_MAX_PERCENTAGE': 'Set Maximum Coverage',
    'EDIT_MAX_PERCENTAGE': 'Edit Maximum Coverage',
    'COPY': 'Copy',
    'LINK_COPIED': 'Link Copied',
    'THANK_YOU': 'Thank You!',
    'CONTRACT_NOW_PENDING': "Contract Now Pending Practice's Signature",
    'RECEIVE_EMAIL_NEXT_WORKING_DAY': 'You should receive an email within the next business day.',
    'PLEASE_ENTER_ACCESS_CODE': 'Please Enter Your ACCESS CODE',
    'TO_VIEW_PLAN': 'To View Your Treatment & Payment Plan',
    'ACCESS_CODE': 'Access Code',
    'LAST_DIGITS_OF_PHONE_NUMBER': 'Last 4 Digits of Your Phone Number',
    'ENTER_YPUR_ACCESS_CODE': 'Enter Your Access Code',
    'BILLING_DEPARTMENT_EMAIL': 'Billing Department Email',
    'RECEIVED': 'Received',
    'OFFLINE': 'Offline',
    'BEST_VIEWED': 'Best viewed with',
    'PENDING_TREATMENT_PLAN_APPROVALS': 'Pending Treatment Plan Approvals',
    'PENDING_CONTRACT_APPROVALS': 'Pending Contract Approvals',
    'FAILED_PAYMENTS': 'Failed Payments',
    'SUCCESSFUL_PAYMENTS': 'Successful Payments',
    'TAX_FEE': 'Tx Fee',
    'DUE_DATE': 'Due Date',
    'DAYS_PAST_DUE': 'Days Past Due',
    'AMOUNT_PAST_DUE': 'Amount Past Due',
    'PAYMENT_DATE': 'Payment Date',
    'PAYMENT_RECEIVED_DATE': 'Payment Received On',
    'METHOD': 'Method',
    'GROUP': 'Group',
    'GOOGLE_CHROME': 'Google Chrome',
    'PREFERRED_CONTACT_METHOD': 'Preferred Contact Method',
    'PREFERRED_CONTACT': 'Preferred Contact',
    'SAVE_PRICE_CONFIRMATION_GLOBAL': 'Global settings will override all location pricing settings. Are you sure you want to save?',
    'SAVE_PRICE_CONFIRMATION': 'Are you sure you want to save?',
    'UPDATE_TREATMENT_NAMES_CONFIRMATION': 'Are you sure you want to update treatment option names?',
    'UPDATE_RP_DETAILS_CONFIRMATION': 'Are you sure you want to update Responsible Party details?',
    'UPDATE_CONFIRMATION': 'Are you sure you want to update?',
    'UPDATE_AUTO_RENEWAL_CONFIRMATION':'Are you sure you want to turn',
    'UPDATE_MONTHLY_AUTO_RENEWAL':'Update Monthly Auto-Renewal',
    'DATA': 'data',
    'MONTHLY_PAYMENT_DATE': 'Monthly Payment Date',
    'PRACTICE_INACTIVE_PLEASE_CONTACT': 'Practice is not active. Please contact your practice admin.',
    'IN_OFFICE_PAYMENTS': 'In-Office Payments',
    'ACCOUNT_STATUS': 'Account Status',
    'REFERRAL_GALLERY': 'Referral Gallery',
    'REFERRAL_GALLERY_LINK': 'Referral Gallery Link',
    'ACTIVE': 'Active',
    'INACTIVE': 'Inactive',
    'PRACTICE_ACCOUNT_INACTIVE': "Practice's Account is Inactive",
    'PRACTICE_ACCOUNT_RESTRICT_SOON': "Your practice's OrthoCatapult® subscription payment has failed; access to OrthoCatapult will be restricted on",
    'UNLESS_RECEIVED': 'unless payment is received.',
    'CONTACT_ADMIN_TO_AVOID': "Please have your Location Manager or Practice Admin update the practice's credit card payment details immediately to avoid account restrictions.",
    'CONTACT_ADMIN_FOR_PAYMENT': "Please alert your Location Manager or Practice Admin of this issue. Once they update the practice's credit card payment details, the restrictions will be lifted immediately.",
    'CONTACT_ADMIN_WHEN_EXPIRED': "Please alert your Location Manager or Practice Admin of this issue. Once they reactivate the subscription, your access will be immediately restored.",
    'PRACTICE_ACCOUNT_RESTRICTED': "Your practice's OrthoCatapult® subscription payment is more than 14 days past due; access to OrthoCatapult is now restricted until the overdue balance is received.",
    'PRACTICE_ACCOUNT_EXPIRED': "Your practice's OrthoCatapult® subscription expired on",
    'PRACTICE_ACCOUNT_INACTIVE_DESCRIPTION': 'Please have your Practice Admin renew your subscription or update your payment information immediately.',
    'SUBSCRIPTION_EXPIRED_ON': "Your practice's OrthoCatapult® subscription expired on",
    'ENABLE_TO_REACTIVATE': "To reactivate your subscription and restore access, please enable Monthly Auto-Renewal below:",
    'MONTHLY_SUBSCRIPTION_FEE': 'Monthly Subscription Fee',
    'REACTIVATE': 'Reactivate',
    'MIDDLE_NAME': 'Middle Name',
    'NICKNAME': 'Nickname',
    'CANCEL_TRACKING': 'Cancel Tracking',
    'TREATMENT_PLAN_DELETE_CONFIRMATION': 'The treatment plan will be deleted. Are you sure?',
    'DOWNLOAD': 'Download',
    'PRINT': 'Print',
    'CONTRACT_SIGNED': 'Contract Signed',
    'OPEN_TAB': 'Open in new tab',
    'DOCUSIGN_DOWNLOAD_DESC': 'Would you like to download or print the contract?',
    'DOCUSIGN_DOWNLOAD_DESC_WITHOUT_PRINT': 'Would you like to download the contract?',
    'DUPLICATE_LTR_TITLE': 'ERROR: Duplicate Lifetime Retainer Subscription',
    'DUPLICATE_LTR_DESC': 'This patient has already subscribed to your Lifetime Retainer program.',
    'DUPLICATE_LTR_DESC_2': 'Please void this contract and resend a revised Treatment Plan.',
    'DUPLICATE_LTR_DESC_3': 'Note: This error occurred due to your TC\'s recent manual adjustment to this patient\'s Lifetime Retainer status after sending the Treatment Plan.',
    'TREATMENT_PLAN_DELETE_SUCCESS': 'Treatment plan deleted successfully',
    'TRACKING_CANCELLED': 'Communication tracking cancelled successfully',
    'CONTACT_MIDDLE_NAME': 'Contact Middle Name',
    'CANCEL_EMAIL_TRACKING': 'The triggered email from the system will be cancelled. Are you sure?',
    'CANCEL_COMMUNICATION_TRACKING': 'The triggered communication from the system will be cancelled.',
    'ARE_YOU_SURE': 'Are you sure?',
    'CANCELLED_TRACKING': 'Tracking cancelled',
    'TREATMENT_EXPIRED': 'Treatment expired',
    'TREATMENT_NOT_STARTED': 'Treatment not started',
    'POWERED_BY_ORTHOGALLERY': 'Powered by OrthoGallery',
    'POWERED_BY_ORTHOCALCULATOR': 'Powered by OrthoCalculator',
    'LIMITED_TREATMENT_OPTION': 'Limited Treatment Option',
    'PROJECTED_LIMTED_TREATMENT_TIME': 'Projected LIMITED Tx Time',
    'COMPREHENSIVE_OPTIONS': 'Comprehensive Options',
    'LIMITED_OPTIONS': 'Limited Options',
    'USER_TYPE': 'User Type',
    'USER_NAME': 'User Name',
    'DOWN_PAYMENT_STATUS': 'Down Payment Status',
    'NO_DOWN_PAYMENT': 'Not Applicable',
    'SELECT_TREATMENTS': 'Select Treatments',
    'SELECT_YEARS': 'Select Years',
    'IMMEDIATE_PATIENT_PAYMENT': 'Immediate Patient Payment',
    'AFTER_SIGNING': 'After Signing Contract',
    'PRICING_LABELS_RENAMED': 'Pricing labels renamed successfully',
    'INVALID_ENTRY': 'Provide a valid entry',
    'NONE': 'None',
    'TERMS_OF_USE': 'Terms Of Use',
    'PRIVACY_POLICY': 'Privacy Policy',
    'NAME_ON_THE_CARD': 'Name on the card',
    'STOP_RECURRING_PAYMENT': 'Stop Recurring Payment',
    'RECURRING_PAYMENT_STOPPED_SUCCESS': 'Recurring payment stopped successfully',
    'RECURRING_PAYMENT_STOPPED': 'Recurring payment stopped',
    'RECENT_ONLINE_PAYMENTS': 'Recent Online Payments',
    'PAYMENT_AMOUNT': 'Payment Amount',
    'TOTAL_DAYS_PAST_DUE': 'Total Days Past Due',
    'LAST_PAYMENT_DATE': 'Last Payment Date',
    'TOTAL_BALANCE_DUE': 'Total Balance Due',
    'OFFLINE_PAYMENT': 'Offline Payment',
    'PENDING': 'Pending',
    'DECLINED': 'Declined',
    'PAST_DUE': 'Past Due',
    'PAID': 'Paid',
    'CONFIRM_PAYMENT': 'Confirm Offline Payment',
    'CONFIRM_EMAIL_RECEIPT': 'Send confirmation email with payment receipt',
    'AND': 'and',
    'READ_AND_AGREE': 'I have read and agree to the',
    'SELECT_SUB_CATEGORY': 'Select Sub Category',
    'EDUCATIONAL': 'Educational',
    'TESTIMONIAL': 'Testimonial',
    'QUOTE_EXPIRES_IN': 'Quote Expires in',
    'VIEW_DETAILS': 'View Details',
    'SELECTED_TREATMENT': 'Selected Treatment',
    'PATIENT_RESPONSIBILITY_DETAILS': 'Patient Responsibility Details',
    'SEND_PAYMENT_NOTIFICATION': 'Send Down Payment Reminder',
    'PAYMENT_NOTIFICATION_MAIL_CONFIRMATION': "Down Payment Reminder & Payment Details Page will be sent to the Responsible Party (Email & SMS). Are you sure?",
    'PAYMENT_NOTIFICATION_MAIL_SUCCESS': 'Payment Reminder sent successfully',
    'PAYMENT_REMINDER': 'Payment Reminder',
    'DOWN_PAYMENT_REMINDER': 'Down Payment Reminder',
    'NEXT': 'Next',
    'PREVIOUS': 'Previous',
    'LAST': 'Last',
    'ONLINE_PAYMENTS': 'Online Payments',
    'SUCCESSFUL_ONLINE_PAYMENTS': 'Successful Online Payments',
    'OVERDUE_ONLINE_PAYMENTS': 'Overdue Online Payments',
    'RECORDED': 'Recorded',
    'PAYMENT_MARKED_AS_RECEIVED_OFFLINE': 'Payment marked as received offline',
    'ONE_TIME_PAYMENT_MARKED_AS_RECEIVED_OFFLINE': 'One Time Additional Payment marked as received offline',
    'ONLINE_PAYMENT_DETAILS': 'Online Payment Details',
    'PDF_PASSWORD_SAVED': 'PDF password saved successfully',
    'PASSWORD_WRONG_FORMAT': 'Password does not meet the complexity requirement',
    'PASSWORD_STRENGTH_DESC': 'Password must be 8 characters including 1 uppercase letter, 1 lowercase letter, 1 special character and a numerical digit.',
    'PARENT_ORTHO_FOLLOW_UP_COMMUNICATIONS': 'Parent Ortho Relapse Communications',
    'PATIENT_ORTHO_FOLLOW_UP_COMMUNICATIONS': 'Patient Ortho Relapse Communications',
    'CONSULTATION_FOLLOW_UP': 'Consultation Follow-Up',
    'REFERRAL_FOLLOW_UP': 'Referral Follow-Up',
    'PARENT_ORTHO_RELAPSE_FOLLOW_UP': 'Parent Ortho Relapse Follow-Up',
    'PATIENT_ORTHO_RELAPSE_FOLLOW_UP': 'Patient Ortho Relapse Follow-Up',
    'RESPONSIBLE_PARTY': 'Responsible Party',
    'RELAPSE_PARENT': 'Relapse Parent',
    'COMMUNICATION_TARGET_DATE': 'Communication Target Date',
    'CHILD_ESTIMATED_FINISH_DATE': 'Child Estimated Finish Date',
    'PATIENT_ORTHO_RELAPSE_TARGET_DATE': 'Patient Ortho Relapse Target Date',
    'TREATMENT_START_DATE': 'Treatment Start Date',
    'REFERRAL_DATE': 'Referral Date',
    'CONTACTED': 'Contacted',
    'ADVANCE_FILTER': 'Advanced Filter',
    'SHOW_LESS': 'Show Less',
    'SHOW_ALL': 'Show All',
    'EXAMPLE_CASE_GALLERY': 'Example Case Gallery',
    'VIEW_GALLERY': 'View Gallery',
    'EXAMPLE_GALLERY_DESCRIPTION': "This Example Case Gallery highlights previously treated patients' results. These examples are for patient education purposes only. Patient compliance and other factors influence final outcomes for each individual patient.",
    'RESPONSIBLE_PARTY_BIRTH_LAST_FOUR_PHONE': "Responsible Party's Birth Year + Last Four Digits of Phone Number (YYYYPPPP)",
    'ADD_APPLIANCE_OPTIONS': 'Add Additional Appliance Options',
    'ADDITIONAL_APPLIANCE_OPTIONS': 'Additional Appliance Options',
    'OPTION_ID': 'Option ID',
    'ADD_NEW_OPTION': 'Add New Appliance Option',
    'EDIT_OPTION': 'Edit Additional Appliance Option',
    'ADDITIONAL_OPTION_ADDED': 'Additional Appliance option added successfully',
    'ADDITIONAL_OPTION_UPDATED': 'Additional Appliance options updated successfully',
    'ADDITIONAL_OPTION_EDITED': 'Additional Appliance option edited successfully',
    'ADDITIONAL_OPTION_DELETED': 'Additional Appliance option deleted successfully',
    'PATIENT_GALLERY_DISPLAY': 'Patient Gallery Display',
    'SHOW_ORTHO_GALLERY_PATIENT_GALLERY': 'Show OrthoGallery Patient Gallery',
    'PATIENT_GALLERY':'Patient Gallery',
    'PATIENT_GALLERY_SETTINGS_UPDATED': 'Patient Gallery Settings Updated',
    'PATIENT_ORTHO_RELAPSE_TREATMENT_OPTION': 'Patient Ortho Relapse Treatment Option',
    'SET_APPLIANCE_OPTIONS': 'Set Additional Appliance Options',
    'APPLIANCE_OPTIONS': 'Additional Appliance Options',
    'ADDITIONAL_APPLIANCE_DETAILS': 'Additional Appliance Details',
    'ADDITIONAL_APPLIANCE': 'Additional Appliance',
    'PAYMENT_PLAN_DETAILS': 'Payment Plan Details',
    'SEND_MAIL_NOTIFICATION': 'Resend Notification',
    'SEND_MAIL_CONFIRMATION': "Orthodontic Treatment Plan & Payment Calculator email & text will be sent to the patient's responsible party. Are you sure?",
    'PRIMARY_INSURANCE': 'Primary Insurance',
    'SECONDARY_INSURANCE': 'Secondary Insurance',
    'COVERAGE': 'Coverage',
    'PAID_TO': 'Paid To',
    'INSURED': 'Insured',
    'ESTIMATED_INSURANCE': 'Estimated Insurance',
    'PAID_TO_PRACTICE': 'Paid to Practice',
    'PAID_TO_INSURED': 'Paid to Insured',
    'USER_DASHBOARD_PERFORMANCE_REPORTS': 'User Dashboard Performance Reports',
    'SHOW_GROUP_REPORTS_DASHBOARD': 'Show group reports on User Dashboards',
    'CHANGES_SAVED': 'Changes saved',
    'APPLIANCE': 'Appliance',
    'NEW_APPLIANCE_NAME': 'New Appliance Name',
    'NEW_INSURANCE_NAME': 'New Insurance Name',
    'ADD_GROUP_NAME': 'Add Group Name',
    'ADD_ATLEAST_ONE_MEMBER': 'Add at least one member',
    'AUTOMATION': 'Automation',
    'AUTOMATION_SETTINGS': 'Automation Settings',
    'AUTOMATIC_CONSULTATION_FOLLOWUP': 'Automatic Consultation Follow-up',
    'AUTOMATIC_PATIENT_RELAPSE_FOLLOWUP': 'Automatic Patient Relapse Follow-up',
    'AUTOMATIC_PARENT_RELAPSE_FOLLOWUP': 'Automatic Parent Relapse Follow-up',
    'AUTOMATIC_REFERRAL_RELAPSE_FOLLOWUP': 'Automatic Referral Relapse Follow-up',
    'AUTOMATIC_NON_START_FOLLOWUP': 'Automatic Non Start Follow-up',
    'CONSULTATION_FOLLOW_UP_AUTOMATION_INFO': 'Includes Consultation and Virtual Consultation Follow-up',
    'LM_QUOTE_SETTINGS_DISABLE_INFO': 'Only Practice Admin can make changes to Automation Settings',
    'LM_QUOTE_SETTINGS_DISABLE_INFO_BTN': 'Only Practice Admin can make changes to Quote & Touchpoints Settings',
    'LM_QUOTE_SETTINGS_DISABLE_INFO_BTN_DUPLICATE': 'Only Practice Admin can make changes to Duplicate Communications Settings',
    'TWO_COMMUNICATION': 'Duplicate Communications',
    'ENABLE_TWO_COMMUNICATION': 'Enable Duplicate Text & Email Communications (Touchpoints 3 & 5 Only)',
    'DOWN_PAYMENT_LESS_THAN': 'Down Payment should not exceed ',
    'MAX_DOWN_PAYMENT': 'Maximum Down Payment',
    'SYSTEM_ADMIN': 'System Admin',
    'FINANCIAL_COORDINATOR': 'Financial Coordinator',
    'FINANCIAL_COORDINATOR_DETAILS': 'Financial Coordinator Details',
    'TREATMENT_TIME': 'Treatment time',
    'FINANCIAL_COORDINATOR_EMAIL': 'Financial Coordinator Email',
    'LIMITED': 'Limited',
    'PLAN_TYPE': 'Plan Type',
    'LOCATION_MANAGER': 'Location Manager',
    'DEFAULT_LOCATION_MANAGER': 'Default Location Manager',
    'ALL_TCs': 'All TCs',
    'WEB_SITE_ADDRESS': 'Web Site Address',
    'ENTER_VALID_WEBSITE_ADDRESS': 'Enter valid website address',
    'SEND_HEALTH_HISTORY_FORM': 'Send Health History Form',
    'HEALTH_HISTORY_FORM_SENT': 'Health History Form sent',
    'HEALTH_HISTORY_FORMS': 'Health History Forms',
    'HEALTH_HISTORY_DATE': 'Health History Date',
    'RP_FIRST_NAME': 'Responsible Party First Name',
    'RP_LAST_NAME': 'Responsible Party Last Name',
    'RP_EMAIL': 'Responsible Party Email',
    'PAYER_ID': 'Payer ID',
    'MAX_PERCENTAGE': 'Max % Treatment Cost',
    'SES_VERIFICATION_MAIL_SENT': 'SES Verification Mail sent',
    'VERIFY_EMAIL': 'Verify Email',
    'BEST_METHOD': 'Best Method',
    'BEST': 'Best',
    'PATIENT_GROUP': 'Patient Group',
    'TREATMENT_FEE': 'Treatment Fee',
    'RECORDED_MONTHLY_PAYMENT': 'Recorded Monthly Payment',
    'RECORDED_DOWN_PAYMENT': 'Recorded Down Payment',
    'MARK_PAYMENT_RECORDED': 'Mark Payment Recorded',
    'MARK_AS_RECORDED_CONFIRMATION': 'The payment will be marked recorded. Are you sure?',
    'AMOUNT_OVERDUE': 'Amount Overdue',
    'LAST_PAYMENT_RECEIVED': 'Last Payment Received',
    'LAST_PAYMENT': 'Last Payment',
    'RECENTLY_EXPIRED_QUOTES': 'Recently Expired Quotes',
    'EXPIRED_QUOTES': 'Expired Quotes',
    'FOLLOW_UP_COMMUNICATION_COUNT': 'Communication Count',
    'PATIENT_FILE': 'Patient File',
    'DATA_DISPOSAL': 'Data Disposal',
    'DATA_DISPOSAL_CONFIRMATION': "Are you sure you want to remove patient's email and phone number?",
    'DATA_DISPOSAL_SUCCESSFUL': 'Data Disposal successful',
    'UPDATE_ALL_FIELDS_TRY_AGAIN': 'Update all fields and try again',
    'INVITATION_RESENT': 'Invitation resent',
    'INVITATION_SENT': 'Invitation sent',
    'ROOM_CREATED': 'The chat room has been created successfully.',
    'HEALTH_HISTORY_FORM_NOT_SENT_NO_EMAIL': 'Health History Form not sent since patient has no email',
    'DATA_DISPOSAL_ALREADY_COMPLETED': 'Data Disposal already completed',
    'CANNOT_DISPOSE_DATA_SINCE_ACTIVE_PLAN': 'Cannot dispose data since active treatment plan present',
    'SAVE_CREATE_TX_PLAN': 'Save & Create Tx Plan',
    'SAVE_CREATE_VIRTUAl_TX_PLAN': 'Save & Create Virtual Tx Plan',
    'SAVE_HHF': 'Save & Send Health Form',
    'UPDATE_CREATE_TX_PLAN': 'Update & Create Tx Plan',
    'UPDATE_HHF': 'Update & Send Health Form',
    'CREATE_TX_PLAN': 'Create Tx Plan',
    'OTHER_ACTIONS': 'Other Actions',
    'PRESENT_HEALTH_HISTORY_FORM': 'Present Health History Form',
    'HEALTH_HISTORY': 'Health History',
    'TX': 'Tx',
    'PDF': 'PDF',
    'SENT': 'Sent',
    'COMPLETED': 'Completed',
    'HEALTH_ID_UNIQUE': 'Health ID should be unique',
    'PRESENT': 'Present',
    'INVALID_YEAR_OF_BIRTH': 'Invalid year of birth',
    'ASSIGN_TO': 'Assign To',
    'REFERRAL_PRACTICE_NAME': 'Referral Practice Name',
    'REFERRAL_PRACTICE_CITY': 'Referral Practice City',
    'DEFAULT_PRACTICE_LOCATION': 'Default Practice Location',
    'REFERRAL_OWNER': 'Referral Owner',
    'TYPE_DECLINE_TO_CONFIRM': 'Type DECLINE to confirm',
    'TIME_ZONE': 'Time Zone',
    'CHAT_HISTORY': 'Chat History',
    'SELECT_USER': 'Select User',
    'PLEASE_SELECT_USER': 'Please select user',
    'DISCOUNT_TYPE': 'Discount Type',
    'TRIGGER_NUMBER': 'Touchpoints Number',
    'RESEND_FOLLOW_UP_MAIL': 'Resend Follow Up Mail',
    'MISCELLANEOUS_DISCOUNT': 'Miscellaneous  Discount',
    'SECONDARY_MISCELLANEOUS_DISCOUNT': '2nd Miscellaneous Discount',
    'SAME_AS_GLOBAL': 'Same as Global',
    'ADD_PREVIOUS_TREATMENT': 'Add Previous Treatment',
    'EDIT_PREVIOUS_TREATMENT': 'Edit Previous Treatment',
    'TREATMENT_DETAILS': 'Treatment Details',
    'TREATMENT_OPTION': 'Treatment Option',
    'PAY': 'Pay',
    'CARD_INFORMATION': 'Card Information',
    'ENTER_CARD_NAME': 'Enter Name on Card',
    'PAY_WITH_CARD': 'Pay with card',
    'ENTER_VALID_DATA': 'Please enter valid data',
    'ENTER_FEE_AMOUNT': 'Please enter custom treatment start fee',
    'PREVIOUS_TREATMENT': 'Previous Treatment',
    'REVISE': 'Revise',
    'WARNING_MSG_REVISE1': 'Revising a treatment plan will void the existing patient contract and require the Responsible Party to start the process over again with OrthoAccept',
    'WARNING_MSG_REVISE2': 'after you revise the treatment plan.',
    'PROCEED_REVISE_PLAN': 'Are you sure you want to REVISE the treatment plan?',
    'TYPE_REVISE_TO_CONFIRM': 'Type REVISE to confirm',
    'TREATMENT_REVISED': 'Treatment plan has been revised successfully',
    'ENVELOPE_DOES_NOT_EXIST': 'Envelope does not exist',
    'MONTHLY_USAGE_SAVED': 'Monthly Usage Fees saved',
    'FAVORITE_REPORTS_SECTION': 'Favorite Reports Section',
    'SELECT_FAVORITE_REPORTS': 'Select the reports to be displayed in the Favorite Reports section',
    'FAVORITE_REPORTS_CHANGED': 'Favorite Reports Changed',
    'SELECT_FAVORITE_REPORT': 'Choose a favorite report',
    'RESET': 'Reset',
    'SET': 'Set',
    'FAV_REPORTS_RESET': 'Favorite Reports reset',
    'RESET_FAV_REPORTS': 'Reset Favorite Reports',
    'TYPE_RESET_TO_CONFIRM': 'Type RESET to confirm',
    'FAV_REPORTS_RESET_CONFIRMATION': 'Do you want to reset your Favourite Reports to the defaults?',
    'INSURANCE': 'Insurance',
    'SEARCH_REFERRAL_SOURCE': 'Search Referral Source',
    'INITIAL_REFERRAL_SOURCE': 'Initial Referral Source',
    'SEARCH_REFERRAL_DOCTOR': 'Search Referral Doctor',
    'SELECT_INSURANCE_PLANS': 'Select Insurance Plans',
    'SEARCH_INSURANCE_PLANS': 'Search Insurance Plans',
    'SELECT_REFERRAL_SOURCES': 'Select Referral Sources',
    'SEARCH_REFERRAL_SOURCES': 'Search Referral Sources',
    'SELECT_APPLIANCES': 'Select Additional Appliance Options',
    'SEARCH_APPLIANCE_OPTIONS': 'Search Additional Appliance Options',
    'SELECTED_APPLIANCE_OPTIONS': 'Selected Additional Appliance Options',
    'LAST_PLAN_ACCESS': 'Last Plan Access',
    'FOLLOW_UP_HISTORY': 'Follow-Up History',
    'DECLINE_TREATMENT': 'Decline Treatment',
    'REFERRAL_SOURCE_MANAGEMENT': 'Referral Source Management',
    'ADD_REFERRAL_SOURCE': 'Add Referral Source',
    'REFERRAL_SOURCES': 'Referral Sources',
    'ADD_NEW_REFERRAL_SOURCE': 'Add New Referral Source',
    'EDIT_REFERRAL_SOURCE': 'Edit Referral Source',
    'SELECT_COUNTRIES': 'Select countries',
    'SEARCH_COUNTRIES': 'Search countries',
    'REFERRAL_SOURCE_ADDED': 'Referral Source added',
    'REFERRAL_SOURCE_UPDATED': 'Referral Sources updated',
    'REFERRAL_SOURCE_DELETED': 'Referral Source deleted',
    'DELETE_NOT_ALLOWED': 'Delete not allowed',
    'LOCATION_SETUP_FEE': 'Location Setup Fee',
    'SET_ADDITIONAL_REFERRAL_SOURCES': 'Set Referral Sources',
    'ADDITIONAL_REFERRAL_SOURCES': 'Additional Referral Sources',
    'CHILD_START_DATE': 'Child Start Date',
    'CAMPAIGN_START_DATE': 'Campaign Start Date',
    'POWERED_BY_PATIENTCATAPULT_TEXT_1': 'Powered by',
    'POWERED_BY_PATIENTCATAPULT_TEXT_2': '| © ' + new Date().getFullYear() + ' Practice Catapult LLC.',
    'ORTHO_CATAPULT_REGISTERED': 'OrthoCatapult®',
    'DISCLAIMER_TEXT1': Contract.DISCLAIMER_TEXT_PAR1,
    'DISCLAIMER_TEXT2': Contract.DISCLAIMER_TEXT_PAR2,
    'DISCLAIMER_AGREED': Contract.DISCLAIMER_AGREED,
    'LICENSE_LINK': Contract.LICENSE_LINK,
    'LICENSEE_CONTENT_PAR1': Contract.LICENSEE_CONTENT_PAR1,
    'LICENSEE_CONTENT_PAR2': Contract.LICENSEE_CONTENT_PAR2,
    'PATIENT_GUARDIAN_TALENT_RELASES_PAR1': Contract.PATIENT_GUARDIAN_TALENT_RELASES_PAR1,
    'PATIENT_GUARDIAN_TALENT_RELASES_PAR2': Contract.PATIENT_GUARDIAN_TALENT_RELASES_PAR2,
    'SHARING_LICENSE_CONTENT_PAR1': Contract.SHARING_LICENSE_CONTENT_PAR1,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR1': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR1,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR2': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR2,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR3': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR3,
    'LICENSEE_CONTENT_RESPONSIBILIIES_PAR4': Contract.LICENSEE_CONTENT_RESPONSIBILIIES_PAR4,
    'LICENSORS_CONTENT_PAR1': Contract.LICENSORS_CONTENT_PAR1,
    'COPYRIGHT_CONTENT_PAR1': Contract.COPYRIGHT_CONTENT_PAR1,
    'CREATE_PLAN':'Create Plan',
    'ADDITIONAL_TX_PLAN':'Additional Treatment Plan?',
    'TYPE_ADDITIONAL_TO_CONFIRM':'Type ADDITIONAL to add an additional Treatment Plan',
    'PENDING_TX_PLAN': 'An Active Treatment Plan Already Exists',
    'WARNING_FOR_PENDING_TX_PLAN': 'This patient has an active Treatment Plan; please edit the existing Treatment Plan to make any necessary changes.',
    'OFFLINE_PAYMENT_WARNING': 'Check whether Offline Payment was completed',
    'NO_CONTRACT_WARNING':'No Contract was found for the selected location. Please select a location with a contract.',
    'NO_CONTRACT_WARNING_HEADING':'Contract not found',
    'RECENT':'Recent',
    'STATEMENTS':'Statements',
    'STATEMENT_NAME':'Statement Name',
    'BILLING':'Billing',
    'NO_OF_TWILIO_USERS': 'Number of Twilio Users',
    'TWILIO_USERS':'Twilio Users',
    'USAGE':'Usage',
    'VIEW_ALL_STATEMENTS':'View All Statements',
    'PAYMENT_INFORMATION':'Payment Information',
    'MONTHLY_USAGE_FEES':'Monthly Usage Fees',
    'STANDARD': 'Standard',
    'DOCUSIGN_ENVELOPE_FEE':'DocuSign Envelope Fee',
    'TWILIO_SMS_USER_FEE':'Twilio SMS User Fee',
    'TREATMENT_START_FEE':'Treatment Start Fee',
    'PATIENT_ORTHO_RELAPSE':'Patient Ortho Relapse',
    'REFERRAL_SOURCE_IS_UPTO_DATE':'Referral Sources are up to date',
    'INSURANCE_PLAN_IS_UPTO_DATE':'Insurance Plans are up to date',
    'ADDITIONAL_OPTION_IS_UPTO_DATE':'Additional Appliances are up to date',
    'LAST_COMMUNICATION':'Last Communication',
    'EMAIL_ADDRESS_MISMATCH': 'Email address mismatch',
    'CONFIRM_EMAIL':'Confirm Email',
    'DAY': 'Day',
    'ORTHO_CONNECT_VC_SETTINGS': 'OrthoConnect Virtual Appointment Settings',
    'VIRTUAL_APPOINTMENTS': 'Virtual Appointments',
    'MONTHLY_USAGE_FEE_APPLY_TEXT': 'Monthly Usage fees apply. Current monthly usage fees are',
    'ACTIVATE_VC': 'Activate OrthoConnect Virtual Appointments',
    'SELECT_VC_COLOR_SCHEME': 'Website Widget Color',
    'ORTHO_CONNECT_THEME': 'OrthoConnect Theme',
    'WEBSITE_HTML_CODE_HINT':'Copy this code and insert in your website',
    'ORTHO_CONNECT_VC_PDF_PASSWORD': 'OrthoConnect PDF Password',
    'WEBSITE_HTML_CODE': 'Website Application HTML Code',
    'CLINIC_EMAIL_ADDRESS': 'Clinic Email Address',
    'SAVE_SETTINGS': 'Save Settings',
    'SELECT_WIDGET_COLOR': 'Select Widget Color',
    'VIRTUAL_APPOINTMENT_SETTINGS_UPDATED': 'Virtual Appointment Settings Updated',
    'Monthly_Charges_Will_Be_Deducted': 'Monthly charges will be deducted',
    'APPLY_SUBSCRIPTION':'Apply Subscription',
    'CHANGES_WILL_BE_CANCELED':'Changes will be canceled ',
    'VIRTUAL_FEE':'Virtual Appointment App Monthly Fee',
    'VIRTUAL_CONSULTATION_COMMUNICATIONS': 'Virtual Consultation Communications',
    'VIRTUAL_CONSULTATION': 'Virtual Consultation',
    'VIRTUAL_CONSULTATION_TC': 'Virtual Consultation TC',
    'TX_PLAN': 'Tx Plan',
    'CREATE_VIRTUAL_TX_PLAN': 'Create Virtual Tx Plan',
    'VA_URL': 'Application URL',
    'CONVERT_TX_PLAN': 'Convert Tx Plan',
    'CONVERT_TO_TX_PLAN_QUESTION': 'Are you sure you want to PRESENT this plan and convert it to an in-person consultation?',
    'VIRTUAL_TREATMENT_PLAN': 'Virtual Treatment Plan',
    'TYPE_CONVERT_TO_CONFIRM': 'Type CONVERT to confirm',
    'WIDGET_POSITION': 'Widget Position ',
    'LEFT': 'Left',
    'RIGHT': 'Right',
    'OF_SCREEN': 'of screen',
    'VIRTUAL_CONSULTATION_PDF':'Virtual Consultation PDF',
    'CLICK_SAVE': 'Click Save button in order to save the password',
    'SEND_HH':'Send Health History',
    'WARNING_FOR_SENDING_HH':'This patient has already completed a Health History form in the past 90 days. Are you sure you want to send another Health History form to this patient?',
    'TYPE_SEND_TO_CONFIRM':'Type SEND to send another Health History Form',
    'EMAIL_USER_EXISTS': 'Email address already in use',
    'PRESENT_HH':'Present Health History',
    'WARNING_FOR_PRESENTING_HH':'This patient has already completed a Health History form in the past 90 days. Are you sure you want to Present another Health History form to this patient?',
    'TYPE_PRESENT_TO_CONFIRM':'Type PRESENT to present another Health History Form',
    'INSURANCE_PLAN_FIELDS_ALREADY_EXISTS':'The fields Insurance type, Country ID, Payer ID must make a unique set.',
    'BASE_FEE': 'Base Fee',
    'TIER_JUMP_FEE': 'Tier Jump Fee',
    'TIER_RANGE': 'Tier Range',
    'LOCATION_BASED_FEES': 'Location Based Fees',
    'TIER_BASED_FEES': 'Tier Based Fees',
    'FEE(S)': 'Fee(s)',
    'MONTHLY_SUBSCRIPTION_FEES': 'Monthly Subscription Fees',
    'MONTHLY_SUBSCRIPTION_FEE_AMOUNT': 'Monthly Subscription Fee Amount',
    'MONTHLY_FEE': 'Monthly Fee',
    'PER_LOCATION': 'Per Location',
    'PER_TIER_JUMP': 'Per Tier Jump',
    'LOCATIONS_PER_TIER': 'Locations / Tier',
    'PER_USER': 'per user',
    'ADDITIONAL_LOCATION_MONTHLY': 'Additional Location Monthly',
    'ADDITIONAL_LOCATION_SETUP_FEE': 'Additional Location Setup Fee',
    'ADDITIONAL_LOCATION_TIER': 'Additional Location Tier',
    'ADDITIONAL_LOCATION_TIER_JUMP': 'Additional Location Tier Jump',
    'ONE_TIME_ADDITIONAL_LOCATION_SETUP_FEE': 'One-Time Additional Location Setup Fee',
    'UPGRADE_SUCCESS': 'Plan Upgraded',
    'NEW': 'New',
    'PRACTICE_ADMIN':'Practice Admin',
    'DELETE_USER': 'Delete User',
    'REASSIGN_DELETE_USER': 'Reassign & Delete User',
    'REASSIGN_DELETE': 'Reassign & Delete',
    'REASSIGN_TO': 'Reassign To',
    'DEFAULT_ROLE': 'Default Role',
    'DEFAULT_USER': 'Default User',
    'LOCATIONS_LIST': 'Locations List',
    'REASSIGN_USERS': 'Reassign Users',
    'REASSIGN_RESPONSIBILITIES': 'Reassign Responsibilities',
    'REASSIGN_UPDATE': 'Reassign and Update',
    'REASSIGN_ALL_USERS': 'Reassign all Users',
    'PLAN_DATE': 'Plan Date',
    'PRATICE_RELATION': 'Patient/ Practice Relationship',
    'EXISTING_FAMILY': 'Existing Family',
    'EXISTING_PATIENT': 'Existing Patient',
    'LANDSCAPE_WARNING': 'OrthoCatapult Application works only in landscape mode. Please rotate your device',
    'VERIFY_EMAIL_ADDRESS':'Verify Email Address',
    'CURRENT_EMAIL_ADDRESS':'The email address we currently have for your account is',
    'SECURITY_PURPOSE':'For security purposes, all users are required to verify their email addresses.',
    'TO_VERIFY_EMAIL_ADDRESS':'To verify your email address now, click the button below.',
    'SEND_VERIFICATION_EMAIL':'Send Verification Email',
    'LOGOUT_MESSAGE': 'Your account is being logged out.',
    'VERIFICATION_EMAIL_SENT':'Verification Email sent to',
    'LOGOUT_WARNING': 'Logout Warning',
    'NOTIFICATIONS': 'Notifications',
    'VERIFY_EMAIL_ADDRESS_FOR_FINANCIAL_COORDINATOR':'Financial Coordinator email verification',
    'CURRENT_EMAIL_ADDRESS_FOR_FINANCIAL_COORDINATOR': 'The email address we currently have for your financial coordinator is',
    'PRACTICE LOCATION': 'Practice Location',
    'TEMPLATE_VERSION': 'Template Version',
    'NON_START_FOLLOW_UP': 'Non Start Follow-Up',
    'TRIGGER_MANAGEMENT': 'Touchpoints Management',
    'RETAINER_PROGRAM_MANAGEMENT': 'Retainer Program Management',
    'ADD_RETAINER_PROGRAM': 'Add Retainer Program',
    'RETAINER_PROGRAM_NAME': 'Retainer Program Name',
    'ADD_RETAINER_PROGRAM_NAME': 'Add Retainer Program Name',
    'EDIT_RETAINER_PROGRAM_NAME': 'Edit Retainer Program Name',
    'SHORT_NAME': 'Short Name',
    'RETAINER_ADDED': 'Retainer Program added',
    'RETAINER_UPDATED': 'Retainer Program updated',
    'RETAINER_DELETED': 'Retainer Program deleted',
    'DEFAULT_NON_START_FOLLOW_UP_DATES': 'Default Non Start Follow Up Dates',
    'TRIGGER_DAY_1':'Touchpoints Day 1',
    'TRIGGER_DAY_2':'Touchpoints Day 2',
    'TRIGGER_DAY_3':'Touchpoints Day 3',
    'TRIGGER_DAY_4':'Touchpoints Day 4',
    'TRIGGER_DATES_SAVED': 'Touchpoints Dates Saved',
    'DOWNLOAD_COMMUNICATION_HISTORY': 'Download Communication History',
    'MAXIMUM_LIMIT_REACHED':'Group member limit reached',
    'ALREADY_GROUP_MEMBER':'The user/patient is already a member of the group',
    'PHONE_TYPE': 'Phone Type',
    'SELECT_GENDER': 'Select Gender',
    'ACTIONS': 'Actions',
    'SI_NO': 'SI No',
    'SUPER_ADMIN': 'Super Admin',
    'ADD_SUPER_ADMIN': 'Add Super Admin',
    'FULL_NAME': 'Full Name',
    'TYPE_DELETE_TO_CONFIRM':'Type DELETE to delete Super Admin',
    'DELETE_SUPER_ADMIN':'Delete Super Admin',
    'WARNING_FOR_DELETING_SUPER_ADMIN':'Are you sure you want to delete the Super Admin?',
    'TYPE_DELETE': 'Type DELETE to confirm',
    'TYPE_DELETE_FOR_PRACTICE':'Type DELETE to delete the Practice',
    'DELETE_PRACTICE':'Delete Practice',
    'WARNING_FOR_DELETING_PRACTICE':'Are you sure you want to delete the Practice?',
    'SELECT_ALL': 'Select All',
    'UNSELECT_ALL': 'Unselect All',
    'SUPER_ADMIN_MANAGEMENT' : 'Super Admin Management',
    'APPROVE_SUPER_ADMIN_CONFIRM': 'Are you sure you want to approve the super Admin?',
    'DECLINE_SUPER_ADMIN_CONFIRM': 'Are you sure you want to decline the super Admin?',
    'SUPER_UPDATE_SUCCESS': 'Super Admin status updated successfully',
    'NO_SUPER_ADMIN' : 'No super admin found',
    'SUPER_ADMIN_NAME' : 'Super Admin Name',
    'ALL_PRACTICES': 'All Practices',
    'HIDE_ALL': 'Hide All',
    'EDIT_SUPER_ADMIN':'Edit Super Admin',
    'ADD_LOCATION_SUCCESSFULL':'You have successfully added a location',
    'ADD_LOCATION_PROCESS_FEE_WARNING':"Please note that you'll be charged a One Time Process Fee for confirmation",
    'ADD_LOCATION_CONFIRMATION_WARNING':'Do you want additional practice location?',
    'ADD_LOCATION_PROCESS_FEE_DETAILS':'You will be charged an Additional Location Setup Fee of $123.99',
    'EDIT_LOCATION': 'Edit Location',
    'ADD_LOCATION': 'Add Location',
    'ADD_LOCATIONS': 'Add Locations',
    'ADD_ATLEAST_ONE_LOCATION': 'Add at least one location',
    'HISTORICAL_DATA': 'Historical Data',
    'QUOTE_&_TRIGGER': 'Quote & Touchpoints',
    'PLEASE_APPLY_PROMOCODE': 'Please apply promo code',
    'YOUTUBE_OR_VIMEO': 'Youtube or Vimeo',
    'OVER_DUE': 'Overdue',
    'CAMPAIGN_TARGET_DATE': 'Campaign Target Date',
    'ANGLE': 'Angle',
    'ENTERPRISE': 'Enterprise',
    'UPLOAD_WARNING': 'Please upload/cancel photos before saving',
    'DEACTIVATE_USER': 'Deactivate User',
    'ACTIVATE_USER': 'Activate User',
    'DEACTIVATE_USER_WARNING': 'Are you sure you want to deactivate this user?',
    'ACTIVATE_USER_WARNING': 'Are you sure you want to activate this user?',
    'ACTIVITY_STATEMENTS': 'Activity Reports',
    'FILE_NAME': 'File Name',
    'CREATED_DATE': 'Created Date',
    'SEARCH_BY_DATE': 'Select Date Range',
    'REPORT_DOWNLOAD_SUCCESS': 'Successfully downloaded activity report',
    'WEEKLY_REPORT_NOT_FOUND': 'Weekly report not found',
    'NETWORK_ISSUE': 'Network issue',
    'PAYMENT_SUCCESS_MSG':'Your payment has been successfully completed.',
    'NO_CASE_STUDY_PRACTICE': 'Practice has not added any Case Studies',
    'STEP_MOTHER': 'Step-Mother',
    'STEP_FATHER': 'Step-Father',
    'OTHER': 'Other',
    'INACTIVTY_WARINING': 'Your session is about to expire! You will be logged out in',
    'SECONDS': 'seconds',
    'ZIP_CODE_ERROR': 'Please add valid ZIP Code/Postal Code',
    'SEND_HEALTH_HISTORY_CONFIRMATION': 'Send Health History Form',
    'SEND_HEALTH_HISTORY_CONFIRMATION_TEXT':'Are you sure you want to send Health History form for',
    'RESEND_HEALTH_HISTORY_CONFIRMATION': 'Resend Health History Form',
    'RESEND_HEALTH_HISTORY_CONFIRMATION_TEXT':'Are you sure you want to resend Health History form for',
    'REVIVE_CONFIRMATION_HEADING': 'Revive Treatment Plan',
    'REVIVE_CONFIRMATION_TEXT': 'Are you sure you want to revive the treatment plan?',
    'TREATMENT_PLAN_REVIVED': 'Treatment plan has been revived successfully',
    'CODE_COPIED': 'Code Copied',
    'TREATMENT_COORDINATOR_CHANGE_WARNING': 'Treatment Coordinator Change',
    'TREATMENT_COORDINATOR_CHANGE_WARNING_MESSAGE': 'All virtual consultation patients will be transferred to the new virtual consultation TC.',
    'CANCEL_CHANGES': 'Cancel Changes',
    'ARE_YOU_SURE_PROCEED': 'Are you sure you want to proceed?',
    'REFERRALS_SELECTED': 'Referrals Selected',
    'PLANS_SELECTED': 'Plans Selected',
    'MAX_COVERAGE_APPLICABLE_IS': 'Maximum Coverage applicable is',
    'OF_TOTAL_TREATMENT_COST': 'of Total Treatment Cost',
    'OF_TOTAL_TREATMENT_FEE' : 'of Total Treatment Fee',
    'MAX_COVERAGE': 'Max Coverage',
    'MAX_COVERAGE_PERCENT': 'Max Coverage %',
    'MIN_DISC_TREAT_FEE': 'Minimum % of discounted treatment fee should not be less than 20',
    'POSTPONE': 'Postpone',
    'POSTPONE_TEXT_1': 'You have selected to postpone the follow-up of',
    'POSTPONE_TEXT_2': "'s treatment plan until",
    'POSTPONE_SUCCESS': 'Follow-up date postponed successfully',
    'UPDATE_POSTPONE_DATE_FAIL': 'Failed to update postpone date',
    'POSTPONE_TREATMENT': 'Postpone Treatment',
    'PENDING_APPROVAL_TX_PLAN': 'Existing Treatment Plan Pending Approval',
    'WARNING_FOR_PENDING_APPROVAL_TX_PLAN': "This patient's existing Treatment Plan is pending contract approval. If changes are necessary, please decline the existing contract, then make necessary changes and resend to the patient.",
    'OPEN_PATIENT_FILE': 'Open the patient file to view treatment plans.',
    'ADDITIONAL_TX_PLAN_WARNING_MSG_1': 'This patient has an active or recent Treatment Plan approved on ',
    'ADDITIONAL_TX_PLAN_WARNING_MSG_2': '. Are you sure you want to create an additional Treatment Plan?',
    'MISC_DISCOUNT_ERROR': 'Miscellaneous Discount should be greater than zero',
    'LIFETIME_RETAINERS': 'Lifetime Retainers',
    'RETAINER_SUBSCRIPTIONS': 'Retainer Subscriptions',
    'RETAINER_SUBSCRIPTION': 'Retainer Subscription',
    'PROGRAM': 'Program',
    'ENROLLED': 'Enrolled',
    'LTR_ACTIVATE_CHECKBOX_1': 'I confirm this patient has previously enrolled in our practice\'s',
    'LTR_ACTIVATE_CHECKBOX_2_1': 'I understand this action is irreversible and will remove the',
    'LTR_ACTIVATE_CHECKBOX_2_2': 'opt-in from all future treatment plans for this patient.',
    'ACTIVATE_LTR': 'Retainer Subscription Activation',
    'LTR_UPDATE_MESSAGE': 'This action is exclusively for patients who have PREVIOUSLY opted into your',
    'LTR_UPDATE_MESSAGE1_1': 'Are you sure you want to activate the',
    'LTR_UPDATE_MESSAGE1_2': 'for this patient?',
    'LTR_UPDATE_MESSAGE2': 'Once activated, this CANNOT be reversed.',
    'TYPE_ACTIVATE_TO_CONFIRM': 'Type ACTIVATE to proceed',
    'CONTINUE': 'Continue',
    'WARNING': 'Warning',
    'TELEPHONE_FOLLOWUP_CALL': 'Telephone Follow-Up Call',
    'INSTANT_ACTION_LIST': 'Instant Action List',
    'SEND_SELECTED': 'Send Selected',
    'SEND_ALL': 'Send All',
    'TRIGGER_SENT': 'Touchpoints sent',
    'TYPE': 'Type',
    'NO_ACTION_ITEMS': 'You don\'t have any action items right now',
    'PLAN_STARTED': 'Plan already started',
    'PLAN_DECLINED': 'Plan already declined',
    'INVALID_TX_PLAN_ID': 'Invalid treatment plan',
    'SELECTED': 'Selected',
    'SELECTION': 'Selection',
    'AUTOMATIC_TRIGGER_UPDATED': 'Automatic touchpoints updated',
    'DATA_SYNC_ERROR_AUTOMATION': 'COO Automation Settings updated. Action Required List will be reloaded',
    'PROGRAM_TITLE': 'Program Title',
    'RETAINER_PROGRAM_FEE_GREATER_THAN_ZERO': 'Retainer Program Fee should be greater than zero',
    'VOLUME_DISCOUNT': 'Volume Discount',
    'STARTS_PER_MONTH': 'starts/month',
    'ADD_NEW': 'Add New',
    'DELETE_RANGE_CONFIRMATION': 'Are you sure to delete this range?',
    'FEE_WAIVER': 'Fee Waiver',
    'STARTS_PER_MONTH_PER_LOCATION': 'starts/month/location',
    'SMS_USER_FEE': 'SMS User Fee',
    'OTHER_FEES': 'Other Fees',
    'ADDITIONAL_LOCATION_FEES': 'Additional Location Fees',
    'ADDITIONAL_LOCATION_MONTHLY_FEE': 'Additional Location Monthly Fee',
    'ADDITIONAL_LOCATION_FEE_WAIVER_THRESHOLD': 'Additional Location Fee Waiver Threshold',
    'ADDITIONAL_LOCATION_TIER_FEE': 'Additional Location Tier Fee',
    'LOCATIONS_PER_ADDITIONAL_LOCATION_TIER': 'Locations per Additional Location Tier',
    'TREATMENT_START_FEE_AMOUNT': 'Treatment Start Fee Amount',
    'SMS_FEE_AMOUNT': 'SMS Fee Amount',
    'SMS_FEE_WAIVER_THRESHOLD': 'SMS Fee Waiver Threshold',
    'ORTHOCONNECT_FEE': 'OrthoConnect® Fee',
    'ORTHOCONNECT_FEE_WAIVER': 'OrthoConnect® Fee Waiver',
    'ORTHOCONNECT_VIRTUAL_APPOINTMENT': 'OrthoConnect® Virtual Appointment',
    'POSTPONE_DATE_HISTORY': 'Postpone Date History',
    'POSTPONE_DATE': 'Postpone Date',
    'POSTPONED_BY': 'Postponed By',
    'DUAL_ARCH': 'Dual Arch',
    'UPPER_ARCH_ONLY': 'Upper Arch Only',
    'LOWER_ARCH_ONLY': 'Lower Arch Only',
    'ARCH_TREATMENT': 'Arch Treatment',
    'MODALITY_NAME': 'Modality Name',
    'SECONDARY_ADDITIONAL_APPLIANCE': '2nd Additional Appliance',
    '2ND_ADD_APPL_FEE': '2nd Additional Appliance Fee',
    '2ND_ADD_APPL_DETAILS': '2nd Additional Appliance',
    'SELECT_REFERRAL_DOCTOR': 'Please select a Referral doctor',
    'TREATMENT_OPTION_NAME': 'Treatment Option Name',
    'DEFAULT_SELECTION': 'Default Selection',
    'NAME_OPTIONS': 'Name Options',
    'INSURANCE_ADJUSTMENT': 'Insurance adjustment cannot be selected without Primary Insurance',
    'APPLIANCE_DETAILS_UNIQUE': 'Appliance details should be unique',
    'PRIMARY_SECONDARY_DISCOUNT_SHOULD_NOT_SAME': 'Primary & Secondary discount cannot be the same',
    'TREATMENT_OPTION_NAMES_UPDATED': 'Treatment option names updated successfully',
    'ADD_NEW_PARENT': 'Add New Parent/Guardian',
    'ADD_NEW_ERROR': 'Please fill required details to add new parent/guardian',
    'PRIMARY': 'Primary',
    'SET_AS_PRIMARY': 'Set as Primary',
    'CHANGE_RP': 'Change Primary Responsible Party',
    'CONFIRM_PRIMARY_RP_1': 'Are you sure you want to set ',
    'CONFIRM_PRIMARY_RP_2': ' as the Primary Responsible Party?',
    'REMOVE_RP': 'Remove Responsible Party',
    'CONFIRM_REMOVE_RP': 'Are you sure you want to remove ',
    'SELECT_PRIMARY_RP': 'Please select the Primary Responsible Party',
    'TX_LINKED_RP': 'Any changes to the responsible party will also be reflected in the associated treatment plans and patient files.',
    'PATIENT_RP_UPDATE_WARNING': 'Any changes to the responsible party will also be reflected in the associated patient file.',
    'CHILD_RP_SAME_AS_PARENT_RP_ERROR': 'Child & Responsible Party personal details cannot match',
    'EXISTING_RP_WITH_SAME_DATA': 'DUPLICATE: A Responsible Party with these details already exists',
    'RP_WITH_IDENTICAL_CHILD_INFO': 'The updated Responsible Party already has a child patient file with identical information',
    'RP_LINKED_IN_ANOTHER_PT_FILE': 'The responsible party is linked to another patient file with relationship as \'PATIENT\'',
    'CONFIRM_RESPONSIBLE_PARTY': 'Confirm Responsible Party Details',
    'RESPONSIBLE_PARTY_DETAILS_UPDATED': 'Responsible Party Details Updated',
    'RP_DETAILS_CONFIRM_TEXT_1': 'The details of the Responsible Party',
    'RP_DETAILS_CONFIRM_TEXT_2': 'have been updated',
    'RP_DETAILS_CONFIRM_TEXT_3': 'Do you want to create a new Responsible Party file or update the existing file?',
    'UPDATED_RESPONSIBLE_PARTY_INFO': 'This information has been updated',
    'REMOVE_RP_CONFIRM_TEXT_1': 'The Responsible Party ',
    'REMOVE_RP_CONFIRM_TEXT_1_1': 'has been replaced with ',
    'REMOVE_RP_CONFIRM_TEXT_2': 'Do you want to remove or retain the Responsible Party ',
    'REMOVE_RP_CONFIRM_TEXT_2_1': 'from the patient file?',
    'RP_DOES_NOT_EXIST': ' does not exist. Please delete the entry and add it again',
    'UPDATED_RESPONSIBLE_PARTIES': 'Successfully update the responsible parties',
    'RESPONSIBLE_PARTY_DETAILS': 'Responsible Party Details',
    'IS': ' is ',
    'A_CHILD': 'a child ',
    'AN_ADULT': 'an adult ',
    'PATIENT_RP_RELATIONSHIP': 'patient; however, the selected responsible party relationship is ',
    'PLEASE': 'Please',
    'RP_INFO_BELOW': ' the responsible party information listed below',
    'REMOVE': 'Remove',
    'RETAIN': 'Retain',
    'LAST_UPDATED': 'Last Updated',
    'RESPONSIBLE_PARTY_VIEW': 'Responsible Party View',
    'RESPONSIBLE_PARTY_PROFILE': 'Responsible Party Profile',
    'ASSOCIATED_PATIENTS': 'Associated Patients',
    'EXTENDED_FINANCING': 'Extended Financing',
    'SOCIAL_NUMBER': 'Social Security Number',
    'SOCIAL_INSURANCE_NUMBER': 'Social Insurance Number',
    'RESPONSIBLE_PARTY_LISTING':'Responsible Parties',
    'MORE': 'more',
    'HIDE': 'Hide',
    'RP_CANNOT_DELETE': 'Active patient file linked; delete function disabled.',
    'DELETE_RESPONSIBLE_PARTY': 'Delete Responsible Party',
    'WARNING_FOR_DELETING_RESPONSIBLE_PARTY': 'Are you sure you want to delete the Responsible Party',
    'EXISTING_RP_SELECTED': 'RETAIN existing data; reject new details.',
    'NEW_RP_SELECTED': 'OVERWRITE existing data with new details.',
    'RESPONSIBLE_PARTY_DELETED': 'Responsible Party deleted',
    'RESPONSIBLE_PARTY_UPDATED': 'Responsible Party updated successfully',
    'ADD_NEW_RP': 'Add New Responsible Party',
    'CREATE_ADULT_PATIENT': 'Create Adult Patient',
    'CREATE_CHILD_PATIENT': 'Create Child Patient',
    'SAME_AS_PRIMARY': 'Same as Primary',
    'NEW_RP_CREATED': 'New Responsible Party Created',
    'RP_UPDATED': 'Responsible Party details have been updated on',
    'NO_ASSOCIATED_PATIENTS_FOUND': 'No Associated Patients Found',
    'SAVE_DRAFT': 'Save Draft',
    'UPDATE_PLAN': 'Update Plan',
    'TREATMENT_PLAN_SAVE_ERROR': 'Some error occurred while saving plan',
    'TREATMENT_PLAN_SAVE_DRAFT_SUCCESS' : 'Treatment Plan Draft saved successfully ',
    'TREATMENT_PLAN_SAVE_DRAFT_ERROR' : 'Some error occurred while saving draft plan',
    'MAX_INSURANCE_PLANS': 'Maximum Insurance Plans',
    'COUNTRY_INSURANCE_UPDATED': 'Maximum Insurance Plans updated successfully',
    'ORTHODONTIC_INSURANCE_COVERAGE': 'ORTHODONTIC INSURANCE COVERAGE',
    'ADD_ADDITIONAL_INSURANCE': 'Add Additional Insurance',
    'SEARCH_FOR_RESPONSIBLE_PARTY': 'Search for Responsible Party',
    'SEARCH_FOR_PARENT': 'Search for Parent/Guardian',
    'NO_SEARCH_DATA_FOUND': 'No search results were available',
    'SEARCH_RESULTS_FOR': 'Search Results for',
    'SEARCH_RESULTS': 'Search Results',
    'SEARCH_PLACEHOLDER_RP': 'Search by First Name, Last Name, Contact Number, Email',
    'WORKING_DAYS': 'Working Days',
    'SELECT_WORKING_DAYS': 'Atleast one working day selection is mandatory',
    'MALOCCLUSION_CATEGORY_BUTTON': 'Malocclusion Category/Subcategory',
    'MALOCCLUSION_CATEGORY': 'Malocclusion Category',
    'MALOCCLUSION_SUBCATEGORY': 'Malocclusion Subcategory',
    'CATEGORY_SELECTION_WARNING': 'Select the treatment category to view the case study',
    'CS_UNFIT_DELETE': 'The case study cannot be deleted',
    'PAYMENT_PORTAL_LINK': 'Payment Portal Link',
    'SUCCESS_RESEND_PORTAL': 'Successfully resent the Payment Portal Link',
    'COPY_LINK': 'Copy Link',
    'SHARE': 'Share',
    'PORTAL_LINK_COPIED': 'Link Copied to Clipboard',
    'SEND_PAYMENT_PORTAL': 'Resend Payment Portal Link',
    'SEND_PAYMENT_PORTAL_CONFIRMATION': 'The patient\'s Payment Portal Link will be sent to the Responsible Party (Email & SMS). Are you sure?',
    'TX_GROUP': 'Tx Group',
    'TX_MODALITY': 'Tx Modality',
    'INSURANCE_APPLIES': 'Insurance Applies',
    'DOESNOT_APPLY': 'Does Not Apply',
    'SELECTED_APPL_OPTIONS': 'Selected Additional Appliance Options',
    'EDIT_APPL_OPTIONS': 'Edit Additional Appliance Options',
    'EDIT_APPL_OPTION': 'Edit Additional Appliance Option',
    'NEWLY_SELECTED': 'Newly Selected',
    'PREVIOUSLY_SELECTED': 'Previously Selected',
    'BULK_EDIT': 'Bulk Edit',
    'ACCEPTED': 'Accepted',
    'EXPIRED': 'Expired',
    'EXCEL_GENERATING_INFO': 'The Excel report is currently being generated. We will notify you as soon as it\'s ready.',
    'PATIENT_FORMS': 'Patient Forms',
    'PATIENT_SURVEYS': 'Patient Surveys',
    'OVERALL_RATING': 'Overall Rating',
    'RESEND_SURVEY_EMAIL': 'Resend Survey Email',
    'PRESENT_SURVEY_FORM': 'Present Survey Form',
    'SURVEY_EMAIL_RESENT': 'Survey email resent successfully',
    'GENERATE_MASTER_DATA': 'Generate Master Data',
    'MASTER_DATA_GENERATING_INFO': 'The Master Data report is currently being generated. We will notify you as soon as it\'s ready.',
    "LIFE_TIME_RETAINER_OPTION": "Lifetime Retainer Option",
    "REQUIRED": "Required",
    'ADD_ADDITIONAL_APPLIANCE': 'Add Additional Appliance',
    'NAME_ON_CREDIT_CARD': 'Name on Credit Card',
    'MAKE_DEFAULT': 'Make Default',
    'DEFAULT': 'Default',
    'SELECT_CARD_FOR_PAYMENT': 'Select a card for payment',
}